<template>
  <el-container v-loading="loading" id="top" style="height:1000px;">
    <el-header>
      <HeaderView :userName="viewUserName" @calcHeaderSpace="calcHeaderSpace" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="overflow:auto;">
        <el-main>
          <div v-if="cow_select === '' & !cow_history">
            <el-row style="justify-content: right;">
              <el-col :span="3" style="min-width:140px;">
                <div>
                  <el-button color="#EEEEEC" class="operation-btn" @click="newEntry()">
                    <el-icon style="padding-right: 1em;">
                      <IconPlus />
                    </el-icon>新規登録
                  </el-button>
                </div>
              </el-col>
              <el-col :span="11">
                <div>
                  <el-pagination background hide-on-single-page layout="prev, pager, next"
                    :current-page="sortCowsIndex + 1" :page-size="cowsPerPageSize" :total="sortCowsTotalCount"
                    @current-change="pageChange" />
                </div>
              </el-col>
              <el-col :span="3" style="min-width:140px;">
                <div>
                  <el-button color="#EEEEEC" class="operation-btn" @click="openDialog()">
                    <el-icon :style="{ color: icon_color, paddingRight: '1em' }"><icon-adjustment /></el-icon>絞り込み
                  </el-button>
                </div>
              </el-col>
              <el-col :span="1">
                <el-switch v-model="isSearchNumber" inline-prompt size="large"
                  style="--el-switch-on-color: #ffcc00; --el-switch-off-color: #ffcc00;margin-top:0.4em;" active-text="耳標"
                  inactive-text="名前">
                </el-switch>
              </el-col>
              <el-col :span="6">
                <div style="display:flex;position:relative;width:100%;">
                  <el-dropdown ref="dropdown1" @command="handleCommand" max-height="300"
                    style="height:50px;min-width:164px;width:100%;position:absolute;left:0px;top:0px;">
                    <div style="display:flex;position:relative;width:100%;">
                      <el-input ref="elinp" id="elinp" v-model="search_text" v-on:keydown.enter="filterUpdate()"
                        :prefix-icon="IconMagnifyingGlass" :suffix-icon="IconClear" :placeholder="search_text_placeholder"
                        :maxlength="search_text_maxlength" style="height:50px;min-width:164px;z-index: 1999;"
                        @input="validate">
                      </el-input>
                      <div style="width:0px;position:relative;">
                        <el-button type="primary" @click="search_text = ''; filterUpdate();"
                          style="position:absolute;left:-33px;top:0px;height:50px;opacity:0;z-index:1999" />
                      </div>
                    </div>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item v-for="suggestionData in this.suggestionsData" :key="suggestionData.value"
                          :label="suggestionData.label" :value="suggestionData.label" :command="suggestionData.label">{{
                            suggestionData.label
                          }}</el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </el-col>
            </el-row>
            <el-row style="justify-content: right; padding-top: 5px; padding-bottom: 5px;">
              <el-button v-if="filter_emptywomb" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(0)">空胎<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_inseminated" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(1)">人工授精済<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_transfered" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(3)">受精卵移植済<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_pregnant" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(2)">妊娠中<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_adultcattle" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(10)">成牛<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_calf" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(11)">子牛<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_shipping" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(12)">出荷<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_deathdisuse" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(13)">死亡・廃用<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_status_noset" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(14)">状態未選択<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_cow" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(20)">メス<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_bull" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(21)">オス<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_sex_noset" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(22)">性別未選択<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_wagyu" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(30)">黒毛和牛<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_holstein" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(31)">ホルスタイン<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_f1" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(32)">F1<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_redcow" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(33)">赤牛<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_breed_noset" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(34)">種類未選択<el-icon>
                  <IconClear />
                </el-icon></el-button>
              <el-button v-if="filter_in_barn" size="small" color="#EEEEEC" style="color: #383838;" type="primary"
                @click="filterDisable(40)">牛房内の牛<el-icon>
                  <IconClear />
                </el-icon></el-button>
            </el-row>
            <div v-if="tableData.length != 0">
              <el-table :data="tableData" :default-sort="{ prop: 'lastestruson', order: 'descending' }" height="600px"
                stripe @row-click="selectCowInfo">
                <el-table-column label="" :width="headerWidth" />
                <el-table-column style="background: #EEEEEC;" prop="name">
                  <template #header>
                    <label>名前</label>
                    <el-button class="link-icon" link :icon="sortIcons[4]" @click="sortSetting(4)"></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="no" label="個体識別番号">
                </el-table-column>
                <el-table-column prop="breed" label="種類">
                </el-table-column>
                <el-table-column prop="fertilizationdate">
                  <template #header>
                    <label>人工授精日</label>
                    <el-button class="link-icon" link :icon="sortIcons[0]" @click="sortSetting(0)"></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="transferdate">
                  <template #header>
                    <label>受精卵移植日</label>
                    <el-button class="link-icon" link :icon="sortIcons[1]" @click="sortSetting(1)"></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="birthdate">
                  <template #header>
                    <label>出産予定日</label>
                    <el-button class="link-icon" link :icon="sortIcons[2]" @click="sortSetting(2)"></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="lastbirthon">
                  <template #header>
                    <label>最終出産日</label>
                    <el-button class="link-icon" link :icon="sortIcons[3]" @click="sortSetting(3)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-if="!loading & (orgTableData.length == 0 || tableData.length == 0)">
              <el-row class="width100">
                <el-row class="width100" style="justify-content:center;margin-top:10%;">
                  <p class="font_18 font_bold">該当する牛がいません</p>
                </el-row>
                <el-row class="width100" style="justify-content:center;">
                  <img src="@/assets/ImgIllustAlertEmpty.png" />
                </el-row>
              </el-row>
            </div>
            <el-dialog v-model="cowSelectFilterDialog" title="" width="544px">
              <el-row class="bottom-padding">
                <el-col :span="12">
                  <span class="filter-left">牛絞り込み</span>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>
              <el-row></el-row>
              <el-row>
                <el-col :span="12">
                  <span class="filter-left">妊娠状況</span>
                </el-col>
                <el-col :span="12">
                  <span>状態</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_emptywomb" label="空胎" size="large" class="filter-left" />
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_adultcattle" label="成牛" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_inseminated" label="人工授精済" size="large" class="filter-left" />
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_calf" label="子牛" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_transfered" label="受精卵移植済" size="large" class="filter-left" />
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_shipping" label="出荷" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_pregnant" label="妊娠中" size="large" class="filter-left" />
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_deathdisuse" label="死亡・廃用" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12"></el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_status_noset" label="未選択" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span class="filter-left">性別</span>
                </el-col>
                <el-col :span="12">種類</el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_cow" label="メス" size="large" class="filter-left" />
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_wagyu" label="黒毛和牛" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_bull" label="オス" size="large" class="filter-left" />
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_holstein" label="ホルスタイン" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_sex_noset" label="未選択" size="large" class="filter-left" />
                </el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_f1" label="F1" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12"></el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_redcow" label="赤牛" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12"></el-col>
                <el-col :span="12">
                  <el-checkbox v-model="dialog_breed_noset" label="未選択" size="large" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <span class="filter-left">その他</span>
                </el-col>
                <el-col :span="12"></el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-checkbox v-model="dialog_in_barn" label="牛房登録中の牛は必ず表示" size="large" class="filter-left" />
                </el-col>
              </el-row>
              <template #footer>
                <el-row style="justify-content: center;">
                  <el-button class="left-button" round @click="filterClear()">クリア</el-button>
                  <el-button class="right-button" round @click="setFilter()">絞り込み</el-button>
                </el-row>
              </template>
            </el-dialog>
          </div>
          <!-- 編集(履歴) -->
          <div v-if="!loading & cow_select !== '' & cow_select !== '新規登録' & cow_edit & cow_history">
            <el-row :gutter="20" class="history-info">
              <el-select placeholder="" v-model="select_history" @change="changeHistory()">
                <el-option v-for="historyInfo in tableBirthData" :key="historyInfo.birth_id"
                  :label="historyInfo.history_name" :value="historyInfo.history_name" />
              </el-select>
            </el-row>
            <el-row :gutter="20" style="justify-content: right;padding-top: 1em;">
              <el-col :span="3"></el-col>
              <el-col :span="12"></el-col>
              <el-col :span="3"></el-col>
              <el-col :span="6"></el-col>
            </el-row>
            <el-row>
            </el-row>
            <el-row>
            </el-row>
            <el-row>
              <div
                style="color:#383838;background:#F8F8F7;border-radius:8px;overflow-y:auto;width:100%;margin-top:15px;min-width:325px;">
                <el-row class="title-area">出産状況</el-row>
                <el-row class="body-area" style="margin-top:24px;">
                  <el-col :span="3" style="margin-top:5px;min-width:140px;">
                    <div v-for="(bestrus_on, index) in birth_estrus_on" v-bind:key="bestrus_on">
                      <el-row style="margin-bottom:-8px;">
                        <el-col :span="18" v-if="index == 0">発情日</el-col>
                        <el-col :span="18" v-if="index != 0"></el-col>
                        <el-col :span="6"><el-button text color="#EEEEEC" :icon="IconTrash"
                            @click="birth_estrus_on.splice(index, 1)" /></el-col>
                      </el-row>
                      <el-row>
                        <el-date-picker v-model="bestrus_on.date"
                          @change="bestrus_on.date = bestrus_on.date == null ? '' : bestrus_on.date" type="date"
                          format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:180px"
                          :disabled-date="after_1_year" />
                      </el-row>
                    </div>
                    <el-button color="#EEEEEC" link size="large" style="color: #383838;" type="primary"
                      @click="birth_estrus_on.push({ date: '' })">
                      <el-icon style="color: #383838; padding-right: 1em;">
                        <IconPlusCircle />
                      </el-icon>発情日を登録
                    </el-button>
                  </el-col>
                  <el-col :span="13" class="birth" style="margin-top:5px;min-width:232px;">
                    <div style="margin-top: 5px;color:#383838;background:#EEEEEC;border-radius:8px;">
                      <div v-for="(binseminate, index) in birth_inseminate" v-bind:key="binseminate.id">
                        <hr v-if="index !== 0" style="margin: 4px 8px; color:#c3c3c1">
                        <el-row>
                          <el-col :span="5" class="birth" style="padding-left:1em;min-width:130px;">
                            <el-radio-group v-model="binseminate.method_str"
                              @change="change_radio_button(binseminate); calcBirthReserveDate()">
                              <el-row class="birth-input">
                                <el-radio label="0" size="default" style="height:30px;">人工授精</el-radio>
                              </el-row>
                              <el-row class="birth-input">
                                <el-radio label="1" size="default" style="height:30px;">受精卵移植</el-radio>
                              </el-row>
                            </el-radio-group>
                          </el-col>
                          <el-col :span="6" style="min-width:179px;">
                            <el-row v-if="binseminate.method == 0">人工授精日</el-row>
                            <el-row v-if="binseminate.method != 0">受精卵移植日</el-row>
                            <el-date-picker v-if="binseminate.method == 0" v-model="binseminate.date"
                              @change="binseminate.date = binseminate.date == null ? '' : binseminate.date; calcBirthReserveDate()"
                              type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:160px"
                              :disabled-date="after_1_year" />
                            <el-date-picker v-if="binseminate.method != 0" v-model="binseminate.date"
                              @change="binseminate.date = binseminate.date == null ? '' : binseminate.date; calcBirthReserveDate()"
                              type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:160px"
                              :disabled-date="after_1_year" />
                          </el-col>
                          <el-col :span="6" class="birth_s" style="position:relative;min-width:170px;">
                            <el-row v-if="binseminate.method == 0">人工授精師</el-row>
                            <el-row v-if="binseminate.method != 0">移植師</el-row>
                            <el-input v-if="binseminate.method == 0" suffix-icon="ArrowDown" placeholder=""
                              v-model="binseminate.inseminator" style="width:160px" readonly
                              @click="clickInseminatorSelect(index)" v-on:keydown.enter="clickInseminatorSelect(index)"
                              v-on:keydown.space="clickInseminatorSelect(index)" />
                            <el-button v-if="binseminate.method == 0" type="primary"
                              @click="clickInseminatorSelect(index)"
                              style="position:absolute;left:143px;top:26px;opacity: 0;" />
                            <el-input v-if="binseminate.method != 0" suffix-icon="ArrowDown" placeholder=""
                              v-model="binseminate.transfer" style="width:160px" readonly
                              @click="clickTransferSelect(index)" v-on:keydown.enter="clickTransferSelect(index)"
                              v-on:keydown.space="clickTransferSelect(index)" />
                            <el-button v-if="binseminate.method != 0" type="primary" @click="clickTransferSelect(index)"
                              style="position:absolute;left:143px;top:26px;opacity: 0;" />
                          </el-col>
                          <el-col :span="7" class="birth" style="position:relative;min-width:200px;">
                            <el-row v-if="binseminate.method == 0" style="margin-bottom: -6px;">
                              <el-col :span="18">種雄牛名</el-col>
                              <el-col :span="6"><el-button text color="#EEEEEC" :icon="IconTrash" style="margin-top:-3px;"
                                  @click="birth_inseminate.splice(index, 1)" /></el-col>
                            </el-row>
                            <el-row v-if="binseminate.method != 0" style="margin-bottom: -6px;">
                              <el-col :span="18">受精卵</el-col>
                              <el-col :span="6"><el-button text color="#EEEEEC" :icon="IconTrash" style="margin-top:-3px;"
                                  @click="birth_inseminate.splice(index, 1)" /></el-col>
                            </el-row>
                            <el-input v-if="binseminate.method == 0" suffix-icon="ArrowDown" placeholder=""
                              v-model="binseminate.bull_name" style="width:160px" readonly
                              @click="clickBullNameSelect(index)" v-on:keydown.enter="clickBullNameSelect(index)"
                              v-on:keydown.space="clickBullNameSelect(index)" />
                            <el-button v-if="binseminate.method == 0" type="primary" @click="clickBullNameSelect(index)"
                              style="position:absolute;left:159px;opacity: 0;" />
                            <el-input v-if="binseminate.method != 0" suffix-icon="ArrowDown" placeholder=""
                              v-model="binseminate.egg_name" style="width:160px" readonly
                              @click="clickEggNameSelect(index)" v-on:keydown.enter="clickEggNameSelect(index)"
                              v-on:keydown.space="clickEggNameSelect(index)" />
                            <el-button v-if="binseminate.method != 0" type="primary" @click="clickEggNameSelect(index)"
                              style="position:absolute;left:159px;opacity: 0;" />
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <el-button color="#EEEEEC" link size="large" style="color: #383838;" type="primary" @click="birth_inseminate.push(
                      {
                        method: 0, method_str: '0', date: '',
                        inseminator: '', bull_id: '', bull_name: '',
                        transfer: '', egg_id: '', fa_name: '', mo_name: '', egg_name: ''
                      }
                    )">
                      <el-icon style="color: #383838; padding-right: 1em;">
                        <CirclePlusFilled />
                      </el-icon>人工授精(受精卵移植)情報を登録
                    </el-button>
                  </el-col>
                  <el-col :span="8" class="birth" style="min-width:225px;">
                    <div style="margin-top: 5px;color:#383838;background:#EEEEEC;border-radius:8px;">
                      <div v-for="(bpregnancy, index) in birth_pregnancy" v-bind:key="bpregnancy.id">
                        <hr v-if="index !== 0" style="margin: 4px 8px; color:#c3c3c1">
                        <el-row>
                          <el-col :span="12" style="min-width:180px;">
                            <el-row v-if="index == 0" class="birth-input">妊娠鑑定</el-row>
                            <el-row v-if="index != 0" class="birth-input">&nbsp;</el-row>
                            <el-row class="birth-input">
                              <el-select placeholder="" v-model="bpregnancy.is_pregnancy" style="width:180px"
                                @change="calcBirthReserveDate()">
                                <el-option v-for="cow_pregnancy in cow_pregnancy_select" :key="cow_pregnancy.id"
                                  :label="cow_pregnancy.kind" :value="cow_pregnancy.kind" />
                              </el-select>
                            </el-row>
                          </el-col>
                          <el-col :span="12" style="min-width:180px;">
                            <el-row class="birth-input" style="margin-bottom: -6px;">
                              <el-col :span="18">{{ index == 0 ? '妊娠鑑定日' : '' }}</el-col>
                              <el-col :span="6"><el-button text color="#EEEEEC" :icon="IconTrash"
                                  style="margin-top: -3px;" @click="birth_pregnancy.splice(index, 1)" /></el-col>
                            </el-row>
                            <el-row class="birth-input">
                              <el-date-picker v-model="bpregnancy.date"
                                @change="bpregnancy.date = bpregnancy.date == null ? '' : bpregnancy.date; calcBirthReserveDate()"
                                type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder=""
                                style="width:180px" :disabled-date="after_1_year" />
                            </el-row>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <el-button color="#EEEEEC" link size="large" style="color: #383838;" type="primary"
                      @click="birth_pregnancy.push({ is_pregnancy: '妊娠した', date: '' })">
                      <el-icon style="color: #383838; padding-right: 1em;">
                        <IconPlusCircle />
                      </el-icon>妊娠情報を登録
                    </el-button>
                  </el-col>
                </el-row>
                <el-row class="body-area" style="margin-top:32px;">
                  <el-col :span="3" style="min-width:140px;">
                    <div>
                      <el-row>
                        出産予定日
                      </el-row>
                      <el-row>
                        <el-date-picker v-model="birth_reserve_date"
                          @change="birth_reserve_date = birth_reserve_date == null ? '' : birth_reserve_date" type="date"
                          format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:180px"
                          :disabled-date="after_2_year" />
                      </el-row>
                      <el-row style="color:#757575;font-size:x-small;">
                        <span>人工授精日（受精卵移植日）から妊娠期間を自動計算して入力されます。</span>
                        <span>設定画面から妊娠期間を変更できます。</span>
                      </el-row>
                    </div>
                  </el-col>
                  <!-- 子牛番号あり -->
                  <el-col :span="17" v-if="calf_number !== '' | numberView" class="birth" style="margin-top: 5px;">
                    <div
                      style="color:#383838;background:#EEEEEC;border-radius:8px;width:100%;height:auto;padding-bottom:5px;min-width:230px;">
                      <el-row>
                        <el-col :span="5" class="birth_s" style="min-width:160px;">
                          <el-row class="birth-input">出産</el-row>
                          <el-row class="birth-input">
                            <el-select placeholder="" v-model="is_birth" style="width:180px">
                              <el-option v-for="cow_is_birth in cow_birth_select" :key="cow_is_birth.id"
                                :label="cow_is_birth.kind" :value="cow_is_birth.kind" />
                            </el-select>
                          </el-row>
                        </el-col>
                        <el-col :span="6" class="birth_s" style="min-width:180px;">
                          <el-row class="birth-input">出産日</el-row>
                          <el-row class="birth-input">
                            <el-date-picker v-model="is_birth_date"
                              @change="is_birth_date = is_birth_date == null ? '' : is_birth_date" type="date"
                              format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:180px"
                              :disabled-date="after_1_year" />
                          </el-row>
                        </el-col>
                        <el-col :span="6" class="birth_s" style="min-width:195px;">
                          <el-row class="birth-input">
                            <el-col :span="24">子牛名
                              <el-button round color="#DFDFDE" size="small"
                                style="width:76px;color:#383838;margin-left:20%;" type="primary"
                                @click="calfCowSelectDialogView()">選択</el-button>
                            </el-col>
                          </el-row>
                          <el-row class="birth-input"><el-input v-model="calf_name" style="width:180px"
                              :maxlength="maxLength" /></el-row>
                        </el-col>
                        <el-col :span="7" class="birth_s" style="min-width:255px;">
                          <el-row class="birth-input">
                            <el-col :span="24">子牛個体識別番号
                              <el-button round color="#DFDFDE" size="small"
                                style="width:76px;color:#383838;margin-left:5%;" type="primary"
                                @click="calfCowDelete()">解除</el-button>
                            </el-col>
                          </el-row>
                          <el-row class="birth-input">
                            <span style="padding-top:4px;">{{ calf_number }}</span>
                          </el-row>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="4" v-if="calf_number !== '' | numberView" class="birth"
                    style="margin-top:5px;min-width:180px;">
                    <el-row>
                      <el-col :span="12" class="birth_s" style="min-width:180px;">
                        <el-row class="birth-input">羊膜舐め取り</el-row>
                        <el-row class="birth-input">
                          <el-select placeholder="" v-model="amnion" style="width:120px">
                            <el-option v-for="cow_amnion in cow_amnions_select" :key="cow_amnion.id"
                              :label="cow_amnion.kind" :value="cow_amnion.kind" />
                          </el-select>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <!-- 子牛番号なし -->
                  <el-col :span="12" v-if="calf_number === '' & !numberView" class="birth" style="margin-top: 5px;">
                    <div
                      style="color:#383838;background:#EEEEEC;border-radius:8px;width:100%;height:auto;padding-bottom:5px;min-width:200px;">
                      <el-row>
                        <el-col :span="8" class="birth_s" style="min-width:160px;">
                          <el-row class="birth-input">出産</el-row>
                          <el-row class="birth-input">
                            <el-select placeholder="" v-model="is_birth" style="width:180px">
                              <el-option v-for="cow_is_birth in cow_birth_select" :key="cow_is_birth.id"
                                :label="cow_is_birth.kind" :value="cow_is_birth.kind" />
                            </el-select>
                          </el-row>
                        </el-col>
                        <el-col :span="8" class="birth_s">
                          <el-row class="birth-input">出産日</el-row>
                          <el-row class="birth-input">
                            <el-date-picker v-model="is_birth_date"
                              @change="is_birth_date = is_birth_date == null ? '' : is_birth_date" type="date"
                              format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:180px"
                              :disabled-date="after_1_year" />
                          </el-row>
                        </el-col>
                        <el-col :span="8" class="birth_s">
                          <el-row class="birth-input">
                            <el-col :span="24">子牛名
                              <el-button round color="#DFDFDE" size="small" style="color:#383838;margin-left:42%;"
                                type="primary" @click="calfCowSelectDialogView()">選択</el-button>
                            </el-col>
                          </el-row>
                          <el-row class="birth-input"><el-input v-model="calf_name" style="width:180px"
                              :maxlength="maxLength" /></el-row>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="9" v-if="calf_number === '' & !numberView" class="birth" style="margin-top: 5px;">
                    <el-row>
                      <el-col :span="12" class="birth_s">
                        <el-row class="birth-input">羊膜舐め取り</el-row>
                        <el-row class="birth-input">
                          <el-select placeholder="" v-model="amnion" style="width:180px">
                            <el-option v-for="cow_amnion in cow_amnions_select" :key="cow_amnion.id"
                              :label="cow_amnion.kind" :value="cow_amnion.kind" />
                          </el-select>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-row>
          </div>
          <!-- 詳細表示(履歴) -->
          <div v-if="cow_select !== '' & cow_select !== '新規登録' & !cow_edit & cow_history">
            <el-row :gutter="20" class="history-info" style="min-width:312px;">
              <el-select placeholder="" v-model="select_history" @change="changeHistory()">
                <el-option v-for="historyInfo in tableBirthData" :key="historyInfo.birth_id"
                  :label="historyInfo.history_name" :value="historyInfo.history_name" />
              </el-select>
            </el-row>
            <el-row :gutter="20" style="justify-content:left;padding-top:1em;padding-left:10px;">
              <el-button color="#EEEEEC" class="operation-btn" @click="editHistory()">
                <el-icon style="color: #383838; padding-right: 1em;">
                  <IconPencil />
                </el-icon>編集
              </el-button>
            </el-row>
            <el-row>
            </el-row>
            <el-row>
              <div
                style="color:#383838;background:#F8F8F7;border-radius:8px;width:1472px;min-width:580px;min-height:182px;margin-top:15px;">
                <el-row style="padding-top: 1em;padding-left: 1em;">出産状況</el-row>
                <el-row style="margin-top: 5px;">
                  <el-col :span="3" style="margin-top: 15px;">
                    <el-row class="birth">発情日</el-row>
                    <el-row class="birth">
                      <div class="font-bold long-string width100" v-for="(bestrus_on) in estrus_on_array"
                        v-bind:key="bestrus_on">
                        {{ bestrus_on }}
                      </div>
                      <span v-if="estrus_on_array.length == 0" class="font-bold">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="4" class="birth" style="margin-top: 15px;">
                    <el-row>人工授精</el-row>
                    <el-row>
                      <div class="font-bold long-string width100"
                        v-for="(binseminate_date_name) in inseminate_date_name_array" v-bind:key="binseminate_date_name">
                        <el-row>
                          {{ binseminate_date_name }}
                        </el-row>
                      </div>
                      <span v-if="inseminate_date_name_array.length == 0" class="font-bold long-string">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="4" class="birth" style="margin-top: 15px;">
                    <el-row>受精卵移植</el-row>
                    <el-row>
                      <div class="font-bold long-string width100"
                        v-for="(btransfer_date_name) in transfer_date_name_array" v-bind:key="btransfer_date_name">
                        <el-row>
                          {{ btransfer_date_name }}
                        </el-row>
                      </div>
                      <span v-if="transfer_date_name_array.length == 0" class="font-bold long-string">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="4" class="birth" style="margin-top: 15px;">
                    <el-row>妊娠鑑定</el-row>
                    <el-row>
                      <div class="font-bold long-string width100"
                        v-for="(bpregnancy_date_flg) in pregnancy_date_flg_array" v-bind:key="bpregnancy_date_flg">
                        <el-row>
                          {{ bpregnancy_date_flg }}
                        </el-row>
                      </div>
                      <span v-if="pregnancy_date_flg_array.length == 0" class="font-bold">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="3" class="birth" style="margin-top: 15px;">
                    <el-row>出産</el-row>
                    <el-row>
                      <span v-if="birth_on_status !== ''" class="font-bold">{{ birth_on_status }}</span>
                      <span v-if="birth_on_status === ''" class="font-bold">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="3" class="birth" style="margin-top: 15px;">
                    <el-row>子牛</el-row>
                    <el-row>
                      <span v-if="calf_name_info !== ''" class="font-bold long-string">{{ calf_name_info }}</span>
                      <span v-if="calf_name_info === ''" class="font-bold long-string">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="3" class="birth" style="margin-top: 15px;">
                    <el-row>羊膜舐め取り</el-row>
                    <el-row><span class="font-bold">{{ amnion }}</span></el-row>
                  </el-col>
                </el-row>
              </div>
            </el-row>
            <el-row :gutter="20" style="margin-top:1em;">
              <el-col :span="1"></el-col>
              <el-col :span="8"><span style="font-size:small;">イベント</span></el-col>
            </el-row>
            <el-row :gutter="20" style="justify-content:left;">
              <el-col :span="24">
                <div v-loading="loadingImg" style="width: 100%;height: 345px;">
                  <el-table :data="alertsTable" :default-sort="{ prop: 'date_time', order: 'descending' }"
                    class="event-table" height="330" :show-header="false" stripe>
                    <el-table-column>
                      <template #default="scope">
                        <el-row :gutter="20">
                          <el-col :span="10" style="height:120px;min-width:214px;">
                            <img v-if="scope.row.imageType === 'step'" src="@/assets/imgilluststep_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'eat'" src="@/assets/imgillusteat_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'stance'" src="@/assets/imgilluststance_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'spin'" src="@/assets/imgillustturning_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'foremilk'" src="@/assets/no_image_alert.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'calf'" src="@/assets/imgillustcalf_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imagePath === 'no'" src="@/assets/no_image_alert.png" class="img-size" />
                            <img v-if="scope.row.imageType === 'jpg'" v-bind:src="scope.row.imagePath"
                              crossorigin="use-credentials" class="img-size" @click="ImageDialogView(scope.row)" />
                          </el-col>
                          <el-col :span="14">
                            <el-row style="height:60px;">
                              <p style="font-weight:bold;">{{ scope.row.message }}</p>
                            </el-row>
                            <el-row style="height:60px">
                              <p style="font-size:small;">{{ scope.row.view_date_time }}</p>
                            </el-row>
                          </el-col>
                        </el-row>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template #default="scope">
                        <el-row style="justify-content:right;height:40px;">
                          <el-badge :is-dot="!scope.row.is_read"
                            style="width:100%;position:absolute;top:1px;left:96%;"></el-badge>
                        </el-row>
                        <el-row style="justify-content:right;height:40px;">
                          <el-icon v-if="scope.row.is_lock" style="color:#383838;padding-right:1em;">
                            <Lock />
                          </el-icon>
                        </el-row>
                        <el-row style="justify-content:right;height:40px;">
                          <p v-if="scope.row.is_action" style="color:#383838;margin-block:0em;padding-right:1em;">対応済み</p>
                          <p v-if="scope.row.is_wrong_detect" style="color:#383838;margin-block:0em;padding-right:1em;">
                            誤検知</p>
                        </el-row>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-dialog v-model="dialogImageVisible" title="アラート画像" width="80%" align-center destroy-on-close
            @close="dialogClose('dialogImageVisible')">
            <image-dialog :row="ImageDialogRow" @dialogClose="dialogClose" />
          </el-dialog>
          <!-- 詳細表示 -->
          <div v-if="cow_select !== '' & cow_select !== '新規登録' & !cow_edit & !cow_history">
            <div>
              <el-button color="#EEEEEC" class="operation-btn" @click="cow_open()">
                <el-icon style="color: #383838; padding-right: 1em;">
                  <IconPencil />
                </el-icon>編集
              </el-button>
            </div>
            <el-row>
              <div
                style="color:#383838;background:#F8F8F7;border-radius:8px;width:100%;height:auto;margin-top:32px;padding-bottom:5px;min-width:270px;">
                <el-row class="title-area">個体情報</el-row>
                <el-row class="body-area" style="margin-top: 24px;">
                  <el-col :span="4" style="min-width:167px;">
                    <img id="cow-image" v-if="cow_image" v-bind:src="cow_image" title="牛画像" @error="cow_image = ''"
                      crossorigin="use-credentials" style="width:136px;" />
                    <img id="cow-image" v-if="!cow_image" src="@/assets/no_image.png" title="牛画像"
                      style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="20">
                    <el-row>
                      <el-col :span="4" style="margin-top:0px;min-width:140px;">
                        <el-row>名前</el-row>
                        <el-row>
                          <p class="font-bold long-string">{{ cow_name }}</p>
                        </el-row>
                      </el-col>
                      <el-col :span="4" style="margin-top:0px;min-width:140px;">
                        <el-row>性別</el-row>
                        <el-row>
                          <p class="font-bold">{{ cow_sex }}</p>
                        </el-row>
                      </el-col>
                      <el-col :span="4" style="margin-top:0px;min-width:140px;">
                        <el-row>出生日</el-row>
                        <el-row>
                          <!-- <p class="font-bold">{{ cow_birth }}</p> -->
                          <p class="font-bold">{{ cow_birth_jpn }}</p>
                        </el-row>
                      </el-col>
                      <el-col :span="4" style="margin-top:0px;min-width:140px;">
                        <el-row>個体識別番号</el-row>
                        <el-row>
                          <p class="font-bold">{{ cow_number }}</p>
                        </el-row>
                      </el-col>
                      <el-col :span="4" style="margin-top:0px;min-width:140px;">
                        <el-row>種類</el-row>
                        <el-row>
                          <p class="font-bold">{{ cow_breed }}</p>
                        </el-row>
                      </el-col>
                      <el-col :span="4" style="margin-top:0px;min-width:140px;">
                        <el-row>状態</el-row>
                        <el-row>
                          <p class="font-bold">{{ cow_status }}</p>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-row>
            <el-row>
              <div
                style="color:#383838;background:#F8F8F7;border-radius:8px;width:100%;min-height:182px;margin-top:15px;padding-bottom:15px;min-width:270px;">
                <el-row class="title-area">出産状況</el-row>
                <el-row class="body-area" style="margin-top: 24px;">
                  <el-col :span="4" style="margin-top:5px;min-width:140px;">
                    <el-row class="birth">出産回数</el-row>
                    <el-row class="birth"><span class="font-bold">{{ birth_count }}回</span></el-row>
                  </el-col>
                  <el-col :span="4" class="birth" style="margin-top:15px;min-width:140px;">
                    <el-row>最終発情</el-row>
                    <el-row>
                      <span v-if="estrus_on !== ''" class="font-bold">{{ estrus_on }}</span>
                      <span v-if="estrus_on === ''" class="font-bold">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="4" class="birth" style="margin-top:15px;min-width:140px;">
                    <el-row>最終人工授精</el-row>
                    <el-row>
                      <span v-if="inseminate_on_info !== ''" class="font-bold long-string">{{ inseminate_on_info }}</span>
                      <span v-if="inseminate_on_info === ''" class="font-bold long-string">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="4" class="birth" style="margin-top:15px;min-width:140px;">
                    <el-row>最終受精卵移植</el-row>
                    <el-row>
                      <span v-if="transfer_on_info !== ''" class="font-bold long-string">{{ transfer_on_info }}</span>
                      <span v-if="transfer_on_info === ''" class="font-bold long-string">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="4" class="birth" style="margin-top:15px;min-width:140px;">
                    <el-row>最終妊娠</el-row>
                    <el-row>
                      <span v-if="pregnancy_on !== ''" class="font-bold">{{ pregnancy_on }}</span>
                      <span v-if="pregnancy_on === ''" class="font-bold">なし</span>
                    </el-row>
                  </el-col>
                  <el-col :span="4" class="birth" style="margin-top:15px;min-width:140px;">
                    <el-row>最終出産（死産・流産）</el-row>
                    <el-row>
                      <span v-if="birth_on_status !== ''" class="font-bold">{{ birth_on_status }}</span>
                      <span v-if="birth_on_status === ''" class="font-bold">なし</span>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row class="body-area">
                  <el-button color="#EEEEEC" style="width:104px;margin-left: 2.5em;" round size="small" type="primary"
                    :disabled="birthData.length == 0" @click="history_open()">出産履歴</el-button>
                </el-row>
              </div>
            </el-row>
            <el-row>
              <div
                style="color:#383838;background:#F8F8F7;border-radius:8px;width:100%;margin-top:15px;padding-bottom:25px;min-width:270px;">
                <el-row class="title-area">血統
                  <el-button round color="#EEEEEC" size="small" style="margin-left:2em;color:#383838;" type="primary"
                    @click="isAbbreviationDisplay = !isAbbreviationDisplay">
                    <el-icon style="color: #383838; text-align: center;">
                      <IconArrowDownBold v-if="isAbbreviationDisplay" />
                      <IconArrowUpBold v-if="!isAbbreviationDisplay" />
                    </el-icon>
                  </el-button>
                </el-row>
                <el-row v-if="isAbbreviationDisplay" class="body-area">
                  <el-col :span="4" class="v-center" style="min-width:234px;">
                    <el-row>
                      <el-col :span="8" class="v-center">父牛</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ fa }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" class="v-center" style="padding:6px 44px 0 44px;min-width:211px;">
                    <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="4" class="v-center" style="min-width:170px;">
                    <el-row>
                      <el-col :span="8" class="v-center">祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="4" class="v-center" style="padding:6px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="4" class="v-center" style="min-width:224px;">
                    <el-row>
                      <el-col :span="8" class="v-center">曽祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo_mo_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="!isAbbreviationDisplay" class="body-area">
                  <el-col :span="4" class="v-center" style="min-width:234px;">
                    <el-row>
                      <el-col :span="8" class="v-center">父牛</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ fa }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" id="father_canvas_div" class="v-center"
                    style="padding:0px 44px 0 44px;min-width:211px;">
                    <pedigree-canvas v-if="fatherCanvasEnv" :width="canvasWidth" :height="fatherCanvasHeight"
                      :fCowHeight="ffCowHeight" :mCowHeight="fmCowHeight" />
                  </el-col>
                  <el-col :span="14" id="father_cow" style="min-width:170px;">
                    <el-row id="ff_cow" v-if="!r_side_split">
                      <el-col :span="8" class="v-center" style="min-width:170px;">
                        <el-row>
                          <el-col :span="8" class="v-center">祖父</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ fa_fa }}</span></el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                        <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                      </el-col>
                      <el-col :span="8" class="v-center" style="min-width:224px;">
                        <el-row>
                          <el-col :span="8" class="v-center">曽祖父</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ fa_fa_fa }}</span></el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row id="fm_cow" v-if="!r_side_split">
                      <el-col :span="8" class="v-center" style="min-width:170px;">
                        <el-row style="padding-top: 64px;">
                          <el-col :span="8" class="v-center">祖母</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ fa_mo }}</span></el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="8" class="v-center" style="padding:65px 44px 0 44px;min-width:250px;">
                        <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                      </el-col>
                      <el-col :span="8" class="v-center" style="min-width:224px;">
                        <el-row style="padding-top: 61px;">
                          <el-col :span="8" class="v-center">曽祖父</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ fa_mo_fa }}</span></el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row v-if="r_side_split">
                      <el-col :span="8" style="min-width:170px;">
                        <el-row id="ff_cow">
                          <el-col :span="8" class="v-center">祖父</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ fa_fa }}</span></el-col>
                        </el-row>
                        <el-row id="fm_cow" style="padding-top: 64px;">
                          <el-col :span="8" class="v-center">祖母</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ fa_mo }}</span></el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="r_side_split && !isAbbreviationDisplay">
                  <el-col :span="20" style="min-width:260px;">
                    <el-row>
                      <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                        <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                      </el-col>
                      <el-col :span="8" class="v-center" style="max-width: 100px;">曽祖父</el-col>
                      <el-col :span="8"><span class="font-bold long-string">{{ fa_fa_fa }}</span></el-col>
                    </el-row>
                    <el-row style="padding-top: 61px;">
                      <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                        <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                      </el-col>
                      <el-col :span="8" class="v-center" style="max-width: 100px;">曽祖父</el-col>
                      <el-col :span="8"><span class="font-bold long-string">{{ fa_mo_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="4" style="min-width:170px;">
                  </el-col>
                </el-row>
                <el-row v-if="!isAbbreviationDisplay" class="body-area" style="padding-top:28px;">
                  <el-col :span="4" class="v-center" style="min-width:234px;">
                    <el-row>
                      <el-col :span="8" class="v-center">母牛</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" id="mother_canvas_div" class="v-center"
                    style="padding:0px 44px 0 44px;min-width:211px;">
                    <pedigree-canvas v-if="motherCanvasEnv" :width="canvasWidth" :height="motherCanvasHeight"
                      :fCowHeight="mfCowHeight" :mCowHeight="mmCowHeight" />
                  </el-col>
                  <el-col :span="14" style="min-width:170px;">
                    <el-row id="mf_cow" v-if="!r_side_split">
                      <el-col :span="8" style="min-width:170px;">
                        <el-row>
                          <el-col :span="8" class="v-center">祖父</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ mo_fa }}</span></el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                        <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                      </el-col>
                      <el-col :span="8" class="v-center" style="min-width:224px;">
                        <el-row>
                          <el-col :span="8" class="v-center">曽祖父</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ mo_fa_fa }}</span></el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row id="mm_cow" v-if="!r_side_split">
                      <el-col class="v-center" :span="8" style="min-width:170px;">
                        <el-row style="padding-top: 64px;">
                          <el-col :span="8" class="v-center">祖母</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ mo_mo }}</span></el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="8" class="v-center" style="padding:65px 44px 0 44px;min-width:250px;">
                        <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                      </el-col>
                      <el-col :span="8" class="v-center" style="min-width:224px;">
                        <el-row style="padding-top: 64px;">
                          <el-col :span="8" class="v-center">曽祖父</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ mo_mo_fa }}</span></el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                    <el-row v-if="r_side_split">
                      <el-col :span="8" style="min-width:170px;">
                        <el-row id="mf_cow">
                          <el-col :span="8" class="v-center">祖父</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ mo_fa }}</span></el-col>
                        </el-row>
                        <el-row id="mm_cow" style="padding-top: 64px;">
                          <el-col :span="8" class="v-center">祖母</el-col>
                          <el-col :span="16"><span class="font-bold long-string">{{ mo_mo }}</span></el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="r_side_split && !isAbbreviationDisplay">
                  <el-col :span="20" style="min-width:260px;">
                    <el-row>
                      <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                        <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                      </el-col>
                      <el-col :span="8" class="v-center" style="max-width: 100px;">曽祖父</el-col>
                      <el-col :span="8"><span class="font-bold long-string">{{ mo_fa_fa }}</span></el-col>
                    </el-row>
                    <el-row style="padding-top: 61px;">
                      <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                        <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                      </el-col>
                      <el-col :span="8" class="v-center" style="max-width: 100px;">曽祖父</el-col>
                      <el-col :span="8"><span class="font-bold long-string">{{ mo_mo_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="4" style="min-width:170px;">
                  </el-col>
                </el-row>
              </div>
            </el-row>
            <el-row :gutter="20" style="margin-top:1em;">
              <el-col :span="1"></el-col>
              <el-col :span="8"><span style="font-size:small;">イベント</span></el-col>
            </el-row>
            <el-row :gutter="20" style="justify-content:left;">
              <el-col :span="24">
                <div v-loading="loadingImg" style="width: 100%;height: 345px;">
                  <el-table :data="alertsTable" :default-sort="{ prop: 'date_time', order: 'descending' }"
                    class="event-table" height="330" :show-header="false" stripe>
                    <el-table-column>
                      <template #default="scope">
                        <el-row :gutter="20">
                          <el-col :span="10" style="height:120px;min-width:214px;">
                            <img v-if="scope.row.imageType === 'step'" src="@/assets/imgilluststep_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'eat'" src="@/assets/imgillusteat_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'stance'" src="@/assets/imgilluststance_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'spin'" src="@/assets/imgillustturning_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'foremilk'" src="@/assets/no_image_alert.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'calf'" src="@/assets/imgillustcalf_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imagePath === 'no'" src="@/assets/no_image_alert.png" class="img-size" />
                            <img v-if="scope.row.imageType === 'jpg'" v-bind:src="scope.row.imagePath"
                              crossorigin="use-credentials" class="img-size" @click="ImageDialogView(scope.row)" />
                          </el-col>
                          <el-col :span="14">
                            <el-row style="height:60px;">
                              <p style="font-weight:bold;">{{ scope.row.message }}</p>
                            </el-row>
                            <el-row style="height:60px">
                              <p style="font-size:small;">{{ scope.row.view_date_time }}</p>
                            </el-row>
                          </el-col>
                        </el-row>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template #default="scope">
                        <el-row style="justify-content:right;height:40px;">
                          <el-badge :is-dot="!scope.row.is_read"
                            style="width:100%;position:absolute;top:1px;left:96%;"></el-badge>
                        </el-row>
                        <el-row style="justify-content:right;height:40px;">
                          <el-icon v-if="scope.row.is_lock" style="color:#383838;padding-right:1em;">
                            <Lock />
                          </el-icon>
                        </el-row>
                        <el-row style="justify-content:right;height:40px;">
                          <p v-if="scope.row.is_action" style="color:#383838;margin-block:0em;padding-right:1em;">対応済み</p>
                          <p v-if="scope.row.is_wrong_detect" style="color:#383838;margin-block:0em;padding-right:1em;">
                            誤検知</p>
                        </el-row>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 編集中 -->
          <div v-if="cow_edit & !cow_history">
            <el-row>
              <div
                style="color:#383838;background:#F8F8F7;border-radius:8px;width:1472px;min-height:270px;margin-top:15px;min-width:325px;">
                <el-row class="title-area">個体情報</el-row>
                <el-row class="body-area" style="margin-top: 48px;">
                  <el-col :span="4" style="min-width:167px;">
                    <img id="cow-image" v-if="cow_image" v-bind:src="cow_image" @error="cow_image = ''" title="牛画像"
                      crossorigin="use-credentials" style="width:136px;margin-left: 15px;" />
                    <img id="cow-image" v-if="!cow_image" src="@/assets/no_image.png" title="牛画像"
                      style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="4" style="margin-top:0px;min-width:190px;">
                    <el-row>名前</el-row>
                    <el-row><el-input placeholder="" v-model="cow_name" style="width:180px"
                        :maxlength="maxLength" /></el-row>
                    <el-row>状態</el-row>
                    <el-row>
                      <el-select id="cow_status" placeholder="" v-model="cow_status_edit" style="width:180px">
                        <el-option v-for="cow_state in cow_status_select" :key="cow_state.id" :label="cow_state.kind"
                          :value="cow_state.kind" />
                      </el-select>
                    </el-row>
                  </el-col>
                  <el-col :span="4" style="margin-top:0px;min-width:190px;">
                    <el-row>性別</el-row>
                    <el-row>
                      <el-select id="cow_sex" placeholder="" v-model="cow_sex_edit" style="width:180px">
                        <el-option v-for="cow_sex in cow_sexs_select" :key="cow_sex.id" :label="cow_sex.kind"
                          :value="cow_sex.kind" />
                      </el-select>
                    </el-row>
                  </el-col>
                  <el-col :span="4" style="margin-top:0px;min-width:190px;">
                    <el-row>出生日</el-row>
                    <el-row>
                      <el-date-picker ref="cowBirth" v-model="cow_birth" :disabled-date="after_0_year"
                        @change="cow_birth = cow_birth == null ? '' : cow_birth" type="date" format="YYYY-MM-DD"
                        value-format="YYYY-MM-DD" placeholder="" style="width:180px;z-index:1999;" />
                    </el-row>
                    <el-input v-model="cow_birth_jpn" tabindex="-1" clearable :prefix-icon="IconCalendar"
                      style="width:180px;z-index:2000;margin-top:-65px;" @focus="calendarOpen()"
                      v-on:click="calendarOpen()" @clear="calendarOpenEnabled = false; cow_birth = '';" />
                  </el-col>
                  <el-col :span="4" style="margin-top:0px;min-width:190px;">
                    <el-row>個体識別番号</el-row>
                    <el-row><el-input placeholder="" v-model="cow_number" style="width:180px" :maxlength="10" /></el-row>
                  </el-col>
                  <el-col :span="4" style="margin-top:0px;min-width:190px;">
                    <el-row>種類</el-row>
                    <el-row>
                      <el-select id="cow_breed" placeholder="" v-model="cow_breed_edit" style="width:180px">
                        <el-option v-for="cow_kind in cow_kinds_select" :key="cow_kind.id" :label="cow_kind.kind"
                          :value="cow_kind.kind" />
                      </el-select>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-row>
            <el-row>
              <div
                style="color:#383838;background:#F8F8F7;border-radius:8px;overflow-y:auto;width:100%;margin-top:15px;min-width:325px;">
                <el-row class="title-area">出産状況</el-row>
                <el-row class="body-area" style="margin-top:24px;">
                  <el-col :span="3" style="margin-top:5px;min-width:140px;">
                    <div v-for="(bestrus_on, index) in birth_estrus_on" v-bind:key="bestrus_on">
                      <el-row style="margin-bottom:-8px;">
                        <el-col :span="18" v-if="index == 0">発情日</el-col>
                        <el-col :span="18" v-if="index != 0"></el-col>
                        <el-col :span="6"><el-button text color="#EEEEEC" :icon="IconTrash"
                            @click="birth_estrus_on.splice(index, 1)" /></el-col>
                      </el-row>
                      <el-row>
                        <el-date-picker v-model="bestrus_on.date"
                          @change="bestrus_on.date = bestrus_on.date == null ? '' : bestrus_on.date" type="date"
                          format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:180px"
                          :disabled-date="after_1_year" />
                      </el-row>
                    </div>
                    <el-button color="#EEEEEC" link size="large" style="color: #383838;" type="primary"
                      @click="birth_estrus_on.push({ date: '' })">
                      <el-icon style="color: #383838; padding-right: 1em;">
                        <IconPlusCircle />
                      </el-icon>発情日を登録
                    </el-button>
                  </el-col>
                  <el-col :span="13" class="birth" style="margin-top:5px;min-width:232px;">
                    <div style="margin-top: 5px;color:#383838;background:#EEEEEC;border-radius:8px;">
                      <div v-for="(binseminate, index) in birth_inseminate" v-bind:key="binseminate.id">
                        <hr v-if="index !== 0" style="margin: 4px 8px; color:#c3c3c1">
                        <el-row>
                          <el-col :span="5" class="birth" style="padding-left:1em;min-width:130px;">
                            <el-radio-group v-model="binseminate.method_str"
                              @change="change_radio_button(binseminate); calcBirthReserveDate()">
                              <el-row class="birth-input">
                                <el-radio label="0" size="default" style="height:30px;">人工授精</el-radio>
                              </el-row>
                              <el-row class="birth-input">
                                <el-radio label="1" size="default" style="height:30px;">受精卵移植</el-radio>
                              </el-row>
                            </el-radio-group>
                          </el-col>
                          <el-col :span="6" style="min-width:179px;">
                            <el-row v-if="binseminate.method == 0">人工授精日</el-row>
                            <el-row v-if="binseminate.method != 0">受精卵移植日</el-row>
                            <el-date-picker v-if="binseminate.method == 0" v-model="binseminate.date"
                              @change="binseminate.date = binseminate.date == null ? '' : binseminate.date; calcBirthReserveDate()"
                              type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:160px"
                              :disabled-date="after_1_year" />
                            <el-date-picker v-if="binseminate.method != 0" v-model="binseminate.date"
                              @change="binseminate.date = binseminate.date == null ? '' : binseminate.date; calcBirthReserveDate()"
                              type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:160px"
                              :disabled-date="after_1_year" />
                          </el-col>
                          <el-col :span="6" class="birth_s" style="position:relative;min-width:170px;">
                            <el-row v-if="binseminate.method == 0">人工授精師</el-row>
                            <el-row v-if="binseminate.method != 0">移植師</el-row>
                            <el-input v-if="binseminate.method == 0" suffix-icon="ArrowDown" placeholder=""
                              v-model="binseminate.inseminator" style="width:160px" readonly
                              @click="clickInseminatorSelect(index)" v-on:keydown.enter="clickInseminatorSelect(index)"
                              v-on:keydown.space="clickInseminatorSelect(index)" />
                            <el-button v-if="binseminate.method == 0" type="primary"
                              @click="clickInseminatorSelect(index)"
                              style="position:absolute;left:143px;top:26px;opacity: 0;" />
                            <el-input v-if="binseminate.method != 0" suffix-icon="ArrowDown" placeholder=""
                              v-model="binseminate.transfer" style="width:160px" readonly
                              @click="clickTransferSelect(index)" v-on:keydown.enter="clickTransferSelect(index)"
                              v-on:keydown.space="clickTransferSelect(index)" />
                            <el-button v-if="binseminate.method != 0" type="primary" @click="clickTransferSelect(index)"
                              style="position:absolute;left:143px;top:26px;opacity: 0;" />
                          </el-col>
                          <el-col :span="7" class="birth" style="position:relative;min-width:200px;">
                            <el-row v-if="binseminate.method == 0" style="margin-bottom: -6px;">
                              <el-col :span="18">種雄牛名</el-col>
                              <el-col :span="6"><el-button text color="#EEEEEC" :icon="IconTrash" style="margin-top:-3px;"
                                  @click="birth_inseminate.splice(index, 1)" /></el-col>
                            </el-row>
                            <el-row v-if="binseminate.method != 0" style="margin-bottom: -6px;">
                              <el-col :span="18">受精卵</el-col>
                              <el-col :span="6"><el-button text color="#EEEEEC" :icon="IconTrash" style="margin-top:-3px;"
                                  @click="birth_inseminate.splice(index, 1)" /></el-col>
                            </el-row>
                            <el-input v-if="binseminate.method == 0" suffix-icon="ArrowDown" placeholder=""
                              v-model="binseminate.bull_name" style="width:160px" readonly
                              @click="clickBullNameSelect(index)" v-on:keydown.enter="clickBullNameSelect(index)"
                              v-on:keydown.space="clickBullNameSelect(index)" />
                            <el-button v-if="binseminate.method == 0" type="primary" @click="clickBullNameSelect(index)"
                              style="position:absolute;left:159px;opacity: 0;" />
                            <el-input v-if="binseminate.method != 0" suffix-icon="ArrowDown" placeholder=""
                              v-model="binseminate.egg_name" style="width:160px" readonly
                              @click="clickEggNameSelect(index)" v-on:keydown.enter="clickEggNameSelect(index)"
                              v-on:keydown.space="clickEggNameSelect(index)" />
                            <el-button v-if="binseminate.method != 0" type="primary" @click="clickEggNameSelect(index)"
                              style="position:absolute;left:159px;opacity: 0;" />
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <el-button color="#EEEEEC" link size="large" style="color: #383838;" type="primary" @click="birth_inseminate.push(
                      {
                        method: 0, method_str: '0', date: '',
                        inseminator: '', bull_id: '', bull_name: '',
                        transfer: '', egg_id: '', fa_name: '', mo_name: '', egg_name: ''
                      }
                    )">
                      <el-icon style="color: #383838; padding-right: 1em;">
                        <CirclePlusFilled />
                      </el-icon>人工授精(受精卵移植)情報を登録
                    </el-button>
                  </el-col>
                  <el-col :span="8" class="birth" style="min-width:225px;">
                    <div style="margin-top: 5px;color:#383838;background:#EEEEEC;border-radius:8px;">
                      <div v-for="(bpregnancy, index) in birth_pregnancy" v-bind:key="bpregnancy.id">
                        <hr v-if="index !== 0" style="margin: 4px 8px; color:#c3c3c1">
                        <el-row>
                          <el-col :span="12" style="min-width:180px;">
                            <el-row v-if="index == 0" class="birth-input">妊娠鑑定</el-row>
                            <el-row v-if="index != 0" class="birth-input">&nbsp;</el-row>
                            <el-row class="birth-input">
                              <el-select placeholder="" v-model="bpregnancy.is_pregnancy" style="width:180px"
                                @change="calcBirthReserveDate()">
                                <el-option v-for="cow_pregnancy in cow_pregnancy_select" :key="cow_pregnancy.id"
                                  :label="cow_pregnancy.kind" :value="cow_pregnancy.kind" />
                              </el-select>
                            </el-row>
                          </el-col>
                          <el-col :span="12" style="min-width:180px;">
                            <el-row class="birth-input" style="margin-bottom: -6px;">
                              <el-col :span="18">{{ index == 0 ? '妊娠鑑定日' : '' }}</el-col>
                              <el-col :span="6"><el-button text color="#EEEEEC" :icon="IconTrash"
                                  style="margin-top: -3px;" @click="birth_pregnancy.splice(index, 1)" /></el-col>
                            </el-row>
                            <el-row class="birth-input">
                              <el-date-picker v-model="bpregnancy.date"
                                @change="bpregnancy.date = bpregnancy.date == null ? '' : bpregnancy.date; calcBirthReserveDate()"
                                type="date" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder=""
                                style="width:180px" :disabled-date="after_1_year" />
                            </el-row>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                    <el-button color="#EEEEEC" link size="large" style="color: #383838;" type="primary"
                      @click="birth_pregnancy.push({ is_pregnancy: '妊娠した', date: '' })">
                      <el-icon style="color: #383838; padding-right: 1em;">
                        <IconPlusCircle />
                      </el-icon>妊娠情報を登録
                    </el-button>
                  </el-col>
                </el-row>
                <el-row class="body-area" style="margin-top:32px;">
                  <el-col :span="3" style="min-width:140px;">
                    <div>
                      <el-row>
                        出産予定日
                      </el-row>
                      <el-row>
                        <el-date-picker v-model="birth_reserve_date"
                          @change="birth_reserve_date = birth_reserve_date == null ? '' : birth_reserve_date" type="date"
                          format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:180px"
                          :disabled-date="after_2_year" />
                      </el-row>
                      <el-row style="color:#757575;font-size:x-small;">
                        <span>人工授精日（受精卵移植日）から妊娠期間を自動計算して入力されます。</span>
                        <span>設定画面から妊娠期間を変更できます。</span>
                      </el-row>
                    </div>
                  </el-col>
                  <!-- 子牛番号あり -->
                  <el-col :span="17" v-if="calf_number !== '' | numberView" class="birth" style="margin-top: 5px;">
                    <div
                      style="color:#383838;background:#EEEEEC;border-radius:8px;width:100%;height:auto;padding-bottom:5px;min-width:230px;">
                      <el-row>
                        <el-col :span="5" class="birth_s" style="min-width:160px;">
                          <el-row class="birth-input">出産</el-row>
                          <el-row class="birth-input">
                            <el-select placeholder="" v-model="is_birth" style="width:180px">
                              <el-option v-for="cow_is_birth in cow_birth_select" :key="cow_is_birth.id"
                                :label="cow_is_birth.kind" :value="cow_is_birth.kind" />
                            </el-select>
                          </el-row>
                        </el-col>
                        <el-col :span="6" class="birth_s" style="min-width:180px;">
                          <el-row class="birth-input">出産日</el-row>
                          <el-row class="birth-input">
                            <el-date-picker v-model="is_birth_date"
                              @change="is_birth_date = is_birth_date == null ? '' : is_birth_date" type="date"
                              format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:180px"
                              :disabled-date="after_1_year" />
                          </el-row>
                        </el-col>
                        <el-col :span="6" class="birth_s" style="min-width:195px;">
                          <el-row class="birth-input">
                            <el-col :span="24">子牛名
                              <el-button round color="#DFDFDE" size="small"
                                style="width:76px;color:#383838;margin-left:20%;" type="primary"
                                @click="calfCowSelectDialogView()">選択</el-button>
                            </el-col>
                          </el-row>
                          <el-row class="birth-input"><el-input v-model="calf_name" style="width:180px"
                              :maxlength="maxLength" /></el-row>
                        </el-col>
                        <el-col :span="7" class="birth_s" style="min-width:255px;">
                          <el-row class="birth-input">
                            <el-col :span="24">子牛個体識別番号
                              <el-button round color="#DFDFDE" size="small"
                                style="width:76px;color:#383838;margin-left:5%;" type="primary"
                                @click="calfCowDelete()">解除</el-button>
                            </el-col>
                          </el-row>
                          <el-row class="birth-input">
                            <span style="padding-top:4px;">{{ calf_number }}</span>
                          </el-row>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="4" v-if="calf_number !== '' | numberView" class="birth"
                    style="margin-top:5px;min-width:180px;">
                    <el-row>
                      <el-col :span="12" class="birth_s" style="min-width:180px;">
                        <el-row class="birth-input">羊膜舐め取り</el-row>
                        <el-row class="birth-input">
                          <el-select placeholder="" v-model="amnion" style="width:120px">
                            <el-option v-for="cow_amnion in cow_amnions_select" :key="cow_amnion.id"
                              :label="cow_amnion.kind" :value="cow_amnion.kind" />
                          </el-select>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                  <!-- 子牛番号なし -->
                  <el-col :span="12" v-if="calf_number === '' & !numberView" class="birth" style="margin-top: 5px;">
                    <div
                      style="color:#383838;background:#EEEEEC;border-radius:8px;width:100%;height:auto;padding-bottom:5px;min-width:200px;">
                      <el-row>
                        <el-col :span="8" class="birth_s" style="min-width:160px;">
                          <el-row class="birth-input">出産</el-row>
                          <el-row class="birth-input">
                            <el-select placeholder="" v-model="is_birth" style="width:180px">
                              <el-option v-for="cow_is_birth in cow_birth_select" :key="cow_is_birth.id"
                                :label="cow_is_birth.kind" :value="cow_is_birth.kind" />
                            </el-select>
                          </el-row>
                        </el-col>
                        <el-col :span="8" class="birth_s" style="min-width:180px;">
                          <el-row class="birth-input">出産日</el-row>
                          <el-row class="birth-input">
                            <el-date-picker v-model="is_birth_date"
                              @change="is_birth_date = is_birth_date == null ? '' : is_birth_date" type="date"
                              format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="" style="width:180px"
                              :disabled-date="after_1_year" />
                          </el-row>
                        </el-col>
                        <el-col :span="8" class="birth_s" style="min-width:195px;">
                          <el-row class="birth-input">
                            <el-col :span="24">子牛名
                              <el-button round color="#DFDFDE" size="small" style="color:#383838;margin-left:42%;"
                                type="primary" @click="calfCowSelectDialogView()">選択</el-button>
                            </el-col>
                          </el-row>
                          <el-row class="birth-input"><el-input v-model="calf_name" style="width:180px"
                              :maxlength="maxLength" /></el-row>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>
                  <el-col :span="9" v-if="calf_number === '' & !numberView" class="birth" style="margin-top: 5px;">
                    <el-row>
                      <el-col :span="12" class="birth_s" style="min-width:180px;">
                        <el-row class="birth-input">羊膜舐め取り</el-row>
                        <el-row class="birth-input">
                          <el-select placeholder="" v-model="amnion" style="width:180px">
                            <el-option v-for="cow_amnion in cow_amnions_select" :key="cow_amnion.id"
                              :label="cow_amnion.kind" :value="cow_amnion.kind" />
                          </el-select>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-row>
            <el-row>
              <div
                style="color:#383838;background:#F8F8F7;border-radius:8px;width:1472px;height:auto;margin-top:15px;padding-bottom:25px;min-width:325px;">
                <el-row class="title-area">血統
                  <el-button round color="#EEEEEC" size="small" style="margin-left:2em;color:#383838;" type="primary"
                    @click="isAbbreviationDisplay = !isAbbreviationDisplay">
                    <el-icon style="color: #383838; text-align: center;">
                      <IconArrowDownBold v-if="isAbbreviationDisplay" />
                      <IconArrowUpBold v-if="!isAbbreviationDisplay" />
                    </el-icon>
                  </el-button>
                </el-row>
                <el-row v-if="isAbbreviationDisplay" class="body-area-one-line">
                  <el-col :span="5" style="min-width:220px;">
                    <el-row>
                      <el-col :span="6">父牛</el-col>
                      <el-col :span="16"><el-input v-model="fa" style="width:180px" :maxlength="maxLength" /></el-col>
                      <el-col :span="2"></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="4" style="padding:6px 44px 0 0;min-width:235px;">
                    <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="4" style="min-width:220px;">
                    <el-row>
                      <el-col :span="8">祖父</el-col>
                      <el-col :span="16"><el-input v-model="mo_fa" style="width:180px" :maxlength="maxLength" /></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" style="padding:6px 44px 0 44px;min-width:235px;">
                    <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="4" style="min-width:220px;">
                    <el-row>
                      <el-col :span="8">曽祖父</el-col>
                      <el-col :span="16"><el-input v-model="mo_mo_fa" style="width:180px"
                          :maxlength="maxLength" /></el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="!isAbbreviationDisplay" class="body-area">
                  <el-col :span="5" style="padding-top:48px;min-width:220px;">
                    <el-row>
                      <el-col :span="6">父牛</el-col>
                      <el-col :span="16"><el-input v-model="fa" style="width:180px" :maxlength="maxLength" /></el-col>
                      <el-col :span="2"></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="4" style="padding:10px 44px 0 0;min-width:235px;">
                    <img src="@/assets/pedigree_line1.png" title="牛画像" style="width:136px;margin-left: 45px;" />
                  </el-col>
                  <el-col :span="4" style="min-width:220px;">
                    <el-row>
                      <el-col :span="8">祖父</el-col>
                      <el-col :span="16"><el-input v-model="fa_fa" style="width:180px" :maxlength="maxLength" /></el-col>
                    </el-row>
                    <el-row style="padding-top:70px;">
                      <el-col :span="8">祖母</el-col>
                      <el-col :span="16"><el-input v-model="fa_mo" style="width:180px" :maxlength="maxLength" /></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" style="padding:10px 44px 0 44px;min-width:235px;">
                    <img src="@/assets/pedigree_line2.png" title="牛画像" style="width:136px;margin-left: 45px;" />
                  </el-col>
                  <el-col :span="4" style="min-width:220px;">
                    <el-row>
                      <el-col :span="8">曽祖父</el-col>
                      <el-col :span="16"><el-input v-model="fa_fa_fa" style="width:180px"
                          :maxlength="maxLength" /></el-col>
                    </el-row>
                    <el-row style="padding-top:70px;">
                      <el-col :span="8">曽祖父</el-col>
                      <el-col :span="16"><el-input v-model="fa_mo_fa" style="width:180px"
                          :maxlength="maxLength" /></el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="!isAbbreviationDisplay" class="body-area" style="padding-top:28px;">
                  <el-col :span="5" style="padding-top:22px;min-width:220px;">
                    <el-row style="justify-content: left;">
                      <el-button round color="#EEEEEC" size="small" style="margin-left:200px;color:#383838;"
                        type="primary" @click="moCowSelectDialogView()">選択</el-button>
                    </el-row>
                    <el-row>
                      <el-col :span="6">母牛</el-col>
                      <el-col :span="16"><el-input v-model="mo" style="width:180px" :maxlength="maxLength" /></el-col>
                      <el-col :span="2"></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="4" style="padding: 10px 44px 0 0;min-width:235px;">
                    <img src="@/assets/pedigree_line1.png" title="牛画像" style="width:136px;margin-left: 45px;" />
                  </el-col>
                  <el-col :span="4" style="min-width:220px;">
                    <el-row>
                      <el-col :span="8">祖父</el-col>
                      <el-col :span="16"><el-input v-model="mo_fa" style="width:180px" :maxlength="maxLength" /></el-col>
                    </el-row>
                    <el-row style="padding-top: 70px;">
                      <el-col :span="8">祖母</el-col>
                      <el-col :span="16"><el-input v-model="mo_mo" style="width:180px" :maxlength="maxLength" /></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="5" style="padding: 10px 44px 0 44px;min-width:235px;">
                    <img src="@/assets/pedigree_line2.png" title="牛画像" style="width:136px;margin-left: 45px;" />
                  </el-col>
                  <el-col :span="4" style="min-width:220px;">
                    <el-row>
                      <el-col :span="8">曽祖父</el-col>
                      <el-col :span="16"><el-input v-model="mo_fa_fa" style="width:180px"
                          :maxlength="maxLength" /></el-col>
                    </el-row>
                    <el-row style="padding-top: 70px;">
                      <el-col :span="8">曽祖父</el-col>
                      <el-col :span="16"><el-input v-model="mo_mo_fa" style="width:180px"
                          :maxlength="maxLength" /></el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-row>
          </div>
          <!-- 移植師選択・追加 -->
          <el-dialog v-model="transferDialog" destroy-on-close title="移植師"
            style="width:544px;height:386px;border-radius:8px;">
            <el-row style="padding-bottom:0px;">
              <el-scrollbar height="200px">
                <div style="margin-left:50px;overflow-y:auto;overflow-x:hidden;padding-bottom:0px;">
                  <div v-for="transfer in transfer_select_list" v-bind:key="transfer.id" style="width:391px;">
                    <el-row :gutter="20">
                      <el-col :span="20" class="birth" style="display:relative;">
                        <el-tooltip :content="transfer.transfer" placement="top" effect="dark" show-after="1000"
                          trigger-keys="['Space']">
                          <el-button
                            style="color:#383838;background:#EEEEEC;border:none;border-radius:12px;width:340px;height:44px;padding-top:10px;font-size:medium;margin-bottom:12px;text-align:center;"
                            @click="clickTransfer(transfer.transfer)">
                            <p v-if="transfer.selected != 0" style="font-size:medium;">{{ transfer.transfer }}</p>
                            <p v-if="transfer.selected == 0" style="font-size:medium;font-weight:bold;padding-left:1em;">
                              {{ transfer.transfer }}</p>
                          </el-button>
                        </el-tooltip>
                        <el-icon v-if="transfer.selected == 0"
                          style="color:#383838;position:absolute;top:1em;left:15px;width:1em;font-size:medium;font-weight:bold;">
                          <IconCheck />
                        </el-icon>
                      </el-col>
                      <el-col :span="4" class="birth">
                        <el-button text color="#EEEEEC" :icon="IconTrash"
                          style="margin-top:5px;font-size:large;padding-left:0px;"
                          @click="clickDelTransfer(transfer.transfer)" />
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-scrollbar>
            </el-row>
            <template #footer>
              <el-row style="justify-content: center;">
                <el-input style="width:300px;font-size:large;" placeholder="" v-model="insTransfer"
                  :maxlength="maxLength" />
                <el-button round
                  style="width:76px;height:60px;margin-left:12px;border-radius:30px;color:#383838;background:#EEEEEC;font-size:large;"
                  @click="clickAddTransfer()">追加</el-button>
              </el-row>
            </template>
          </el-dialog>
          <!-- 母牛血統選択 -->
          <el-dialog v-model="moCowSelectDialog" destroy-on-close title="母牛血統選択" align-center
            style="height:795px;width:80%;border-radius:8px;overflow:hidden;">
            <cow-dialog :cowData="moCowSelect" :headerWidth="headerWidth" :farmerId="farmer_id"
              @dialogClose="dialogClose('cowDialog')" @selectedMoCow="selectedMoCow" />
          </el-dialog>
          <!-- 子牛選択 -->
          <el-dialog v-model="calfCowSelectDialog" destroy-on-close title="子牛選択" align-center
            style="height:795px;width:1550px;border-radius:8px;overflow:hidden;">
            <calf-dialog :cowData="calfCowSelect" :headerWidth="headerWidth" :farmerId="farmer_id"
              @dialogClose="dialogClose('calfDialog')" @selectedCalfCow="selectedCalfCow" />
          </el-dialog>
          <!-- 人工授精師選択・追加 -->
          <el-dialog v-model="inseminatorDialog" destroy-on-close title="人工授精師"
            style="width:544px;height:386px;border-radius:8px;">
            <el-row style="padding-bottom:0px;">
              <el-scrollbar height="200px">
                <div style="margin-left:50px;overflow-y:auto;overflow-x:hidden;padding-bottom:0px;">
                  <div v-for="inseminator in inseminator_select_list" v-bind:key="inseminator.id" style="width:391px;">
                    <el-row :gutter="20">
                      <el-col :span="20" class="birth" style="display:relative;">
                        <el-tooltip :content="inseminator.inseminator" placement="top" effect="dark" show-after="1000"
                          trigger-keys="['Space']">
                          <el-button
                            style="color:#383838;background:#EEEEEC;border:none;border-radius:12px;width:340px;height:44px;padding-top:10px;font-size:medium;margin-bottom:12px;text-align:center;"
                            @click="clickInseminator(inseminator.inseminator)">
                            <p v-if="inseminator.selected != 0" style="font-size:medium;">{{ inseminator.inseminator }}
                            </p>
                            <p v-if="inseminator.selected == 0"
                              style="font-size:medium;font-weight:bold;padding-left:1em;">
                              {{ inseminator.inseminator }}</p>
                          </el-button>
                        </el-tooltip>
                        <el-icon v-if="inseminator.selected == 0"
                          style="color:#383838;position:absolute;top:1em;left:15px;width:1em;font-size:medium;font-weight:bold;">
                          <IconCheck />
                        </el-icon>
                      </el-col>
                      <el-col :span="4" class="birth">
                        <el-button text color="#EEEEEC" :icon="IconTrash"
                          style="margin-top:5px;font-size:large;padding-left:12px;"
                          @click="clickDelInseminator(inseminator.inseminator)" />
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-scrollbar>
            </el-row>
            <template #footer>
              <el-row style="justify-content: center;">
                <el-input style="width:300px;font-size:large;" placeholder="" v-model="insInseminator"
                  :maxlength="maxLength" />
                <el-button round
                  style="width:76px;height:60px;margin-left:12px;border-radius:30px;color:#383838;background:#EEEEEC;font-size:large;"
                  @click="clickAddInseminator()">追加</el-button>
              </el-row>
            </template>
          </el-dialog>
          <!-- 種雄牛選択・追加 -->
          <el-dialog v-model="bullNameDialog" destroy-on-close title="種雄牛名"
            style="width:544px;height:406px;border-radius:8px;">
            <el-row style="padding-bottom:0px;">
              <el-scrollbar height="200px">
                <div style="margin-left:50px;overflow-y:auto;overflow-x:hidden;padding-bottom:0px;">
                  <div v-for="bull in bullNameSelectList" v-bind:key="bull.id" style="width:391px;">
                    <el-row :gutter="20" style="justify-content:center;">
                      <el-col :span="20" class="birth" style="display:relative;">
                        <el-tooltip :content="bull.bull_name" placement="top" effect="dark" :show-after="1000"
                          trigger-keys="['Space']">
                          <el-button
                            style="color:#383838;background:#EEEEEC;border-radius:12px;width:340px;height:44px;padding-top:10px;font-size:medium;margin-bottom:12px;text-align:center;"
                            @click="clickBullName(bull.bull_name, bull.bull_id)">
                            <p v-if="bull.selected != 0" style="font-size:medium;">{{ bull.bull_name }}</p>
                            <p v-if="bull.selected == 0" style="font-size:medium;font-weight:bold;padding-left:1em;">
                              {{ bull.bull_name }}</p>
                          </el-button>
                        </el-tooltip>
                        <el-icon v-if="bull.selected == 0"
                          style="color:#383838;position:absolute;top:1em;left:15px;width:1em;font-size:medium;font-weight:bold;">
                          <IconCheck />
                        </el-icon>
                      </el-col>
                      <el-col :span="4" class="birth">
                        <el-button text color="#EEEEEC" :icon="IconTrash"
                          style="margin-top:5px;font-size:large;padding-left:12px;"
                          @click="clickDelBullName(bull.bull_name, bull.bull_id)" />
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-scrollbar>
            </el-row>
            <template #footer>
              <el-row style="justify-content:center;">
                <el-button round
                  style="width:382px;height:60px;border-radius:30px;color:#383838;background:#EEEEEC;font-size:large;"
                  @click="clickAddBullName()">新規追加</el-button>
              </el-row>
            </template>
          </el-dialog>
          <!-- 種雄牛管理 -->
          <el-dialog v-model="bullViewDialog" destroy-on-close title="種雄牛管理" align-center
            style="height:780px;width:1657px;border-radius:8px;overflow-x:auto;" @close="get_bull_data()">
            <bull-dialog :bullId="'新規登録'" :farmerId="farmer_id" :edit="true" :bullData="[]" :modeDialog="true"
              :headerWidth="headerWidth" @dialogClose="dialogClose('bullDialog')" @selectBull="clickBullName" />
          </el-dialog>
          <!-- 受精卵選択・追加 -->
          <el-dialog v-model="eggNameDialog" destroy-on-close title="受精卵"
            style="width:544px;height:406px;border-radius:8px;">
            <el-row style="padding-bottom:0px;">
              <el-scrollbar height="200px">
                <div style="margin-left:50px;overflow-y:auto;overflow-x:hidden;padding-bottom:0px;">
                  <div v-for="egg in eggNameSelectList" v-bind:key="egg.id" style="width:391px;">
                    <el-row :gutter="20" style="justify-content:center;">
                      <el-col :span="20" class="birth" style="display:relative;">
                        <el-tooltip :content="egg.egg_name" placement="top" effect="dark" :show-after="1000"
                          trigger-keys="['Space']">
                          <el-button
                            style="color:#383838;background:#EEEEEC;border-radius:12px;width:340px;height:44px;padding-top:10px;font-size:medium;margin-bottom:12px;text-align:center;"
                            @click="clickEggName(egg.egg_name, egg.egg_id)">
                            <p v-if="egg.selected != 0" style="font-size:medium;">{{ egg.egg_name }}</p>
                            <p v-if="egg.selected == 0" style="font-size:medium;font-weight:bold;padding-left:1em;">
                              {{ egg.egg_name }}</p>
                          </el-button>
                        </el-tooltip>
                        <el-icon v-if="egg.selected == 0"
                          style="color:#383838;position:absolute;top:1em;left:15px;width:1em;font-size:medium;font-weight:bold;">
                          <IconCheck />
                        </el-icon>
                      </el-col>
                      <el-col :span="4" class="birth">
                        <el-button text color="#EEEEEC" :icon="IconTrash"
                          style="margin-top:5px;font-size:large;padding-left:12px;"
                          @click="clickDelEggName(egg.egg_name, egg.egg_id)" />
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-scrollbar>
            </el-row>
            <template #footer>
              <el-row style="justify-content:center;">
                <el-button round
                  style="width:382px;height:60px;border-radius:30px;color:#383838;background:#EEEEEC;font-size:large;"
                  @click="clickAddEggName()">新規追加</el-button>
              </el-row>
            </template>
          </el-dialog>
          <!-- 受精卵管理 -->
          <el-dialog v-model="eggViewDialog" destroy-on-close title="受精卵管理" align-center
            style="height:780px;width:1657px;border-radius:8px;overflow-x:auto;" @close="get_egg_data()">
            <egg-dialog :eggId="'新規登録'" :farmerId="farmer_id" :edit="true" :eggData="[]" :modeDialog="true"
              :headerWidth="headerWidth" @dialogClose="dialogClose('eggDialog')" @selectEgg="clickEggName" />
          </el-dialog>
        </el-main>
        <el-footer style="overflow-x:auto;background:white;height:100px;padding-Top:44px;">
          <div style="width:100%;overflow:auto;">
            <el-row v-if="cow_select !== '' & cow_select !== '新規登録' & !cow_edit & !cow_history"
              style="justify-content:center;">
              <el-button class="button-style" color="#EEEEEC" type="primary"
                @click="cow_select = ''; filterAllReset()">戻る</el-button>
            </el-row>
            <el-row v-if="cow_edit & !cow_history & cow_select === '新規登録'" style="justify-content:center;">
              <el-button class="button-style" color="#EEEEEC" round type="primary" @click="filterAllReset(); editCancel()"
                style="margin-right:2%;">キャンセル</el-button>
              <el-button class="button-style" color="#ffdf5e" round type="primary" @click="cowInfoEntry();">保存</el-button>
            </el-row>
            <el-row v-if="cow_edit & !cow_history & cow_select !== '新規登録'" style="justify-content:right;">
              <el-button class="button-style" color="#EEEEEC" round type="primary" @click="filterAllReset(); editCancel()"
                style="margin-right:2%;">キャンセル</el-button>
              <el-button class="button-style" color="#ffdf5e" round type="primary" @click="cowInfoEntry()">保存</el-button>
              <el-button class="button-style-short" color="#EEEEEC" type="primary" @click="cowInfoDataDelete()"
                style="margin-left:25%;margin-right:5%;">
                <el-icon style="color: #383838; padding-right: 0.5em;">
                  <IconTrash />
                </el-icon>削除
              </el-button>
            </el-row>
            <!-- 履歴 -->
            <el-row v-if="cow_select !== '' & !cow_edit & cow_history" style="justify-content:center;">
              <el-button class="button-style" color="#EEEEEC" round type="primary" @click="historyCancel()">戻る</el-button>
            </el-row>
            <el-row v-if="cow_edit & cow_history" style="justify-content:right;">
              <el-button class="button-style" color="#EEEEEC" round type="primary" @click="historyEditCancel()"
                style="margin-right:2%;">キャンセル</el-button>
              <el-button class="button-style" color="#ffdf5e" round type="primary"
                @click="birthInfoEntry()">保存</el-button>
              <el-button class="button-style-short" color="#EEEEEC" round type="primary" @click="birthInfoDelete()"
                style="margin-left:25%;margin-right:5%;">
                <el-icon style="color: #383838; padding-right: 0.5em;">
                  <IconTrash />
                </el-icon>削除
              </el-button>
            </el-row>
          </div>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from './js/cognito';
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import ImageDialog from '../components/ImageDialog.vue';
import ConstParam from './js/const';
import BullDialog from '../components/BullDialog.vue';
import EggDialog from '../components/EggDialog.vue';
import CowDialog from '../components/CowDialog.vue';
import CalfDialog from '../components/CalfDialog.vue';
import { shallowRef } from 'vue'
import * as icons from '../components/icons/modules'
import PedigreeCanvas from '../components/PedigreeCanvas.vue';

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

// 定数定義
const colorYellow = "#FFB600";
const colorNormal = "#383838";
// 数値文字列判定
const isNumberString = n => typeof n === "string" && !isNaN(n);
// 
const constFilterParam = {
  save: true,
  sortParam: [0, 0, 0, 1, 0], // 人工授精日、受精卵移植日、出産予定日、最終出産日、名前
  searchMode: true,
  searchText: "",
  filter_emptywomb: false,
  filter_inseminated: false,
  filter_pregnant: false,
  filter_transfered: false,
  filter_adultcattle: false,
  filter_calf: false,
  filter_shipping: false,
  filter_deathdisuse: false,
  filter_status_noset: false,
  filter_cow: false,
  filter_bull: false,
  filter_sex_noset: false,
  filter_wagyu: false,
  filter_holstein: false,
  filter_f1: false,
  filter_redcow: false,
  filter_breed_noset: false,
  filter_in_barn: false
}

export default {
  name: 'CowManageView',
  components: {
    HeaderView,
    MenuView,
    ImageDialog,
    BullDialog,
    EggDialog,
    CowDialog,
    CalfDialog,
    PedigreeCanvas
  },
  created() {
    this.$store.commit('setCowMenuSelect', '牛管理');
  },
  mounted() {
    this.restore_param();
    this.get_current_user();
    this.setTimer();
  },
  beforeUnmount() {
    clearInterval(this.interval_id);
  },
  data() {
    return {
      filterParam: {},
      cowNumberNames: {},
      suggestionsData: [],
      suggestionsDatas: { cows_name: [], cows_number: [] },
      calendarOpenEnabled: true,
      isAbbreviationDisplay: true,
      r_side_split: false,
      ffCowHeight: 0,
      fmCowHeight: 0,
      mfCowHeight: 0,
      mmCowHeight: 0,
      redrawTimer: 0,
      fatherCanvasEnv: false,
      motherCanvasEnv: false,
      canvasWidth: 133,
      fatherCanvasHeight: 66,
      motherCanvasHeight: 66,
      interval_id: null,
      userType: ConstParam.disable_user_kind,
      cowsPerPageSize: ConstParam.cows_per_page,
      cowSortKey: ConstParam.cow_sort_key,
      sortCowsCowInBarn: false,
      sortCowsIndex: 0,
      sortCowsAscending: true,
      sortOrder: 0,
      sortCowsIndexCount: 0,
      sortCowsTotalCount: 0,
      sortCowsListKey: {},
      sortCowsListKeyArray: [],
      sortCowsListCount: [],
      sortCowsListData: [],
      sortCowsData: [],
      updateSortCowsData: [],
      //
      addNumber: 1,
      addFlag: false,
      deleteIndex: 0,
      deleteFlag: false,
      //
      numberView: false,
      headerWidth: "96px",
      sortLevel: [0, 0, 0, 1, 0],
      sortIndex: -1,
      sortIconNames: ["IconArrowUpDown1", "IconArrowUpDown2", "IconArrowUpDown3"],
      sortIcons: ["IconArrowUpDown1", "IconArrowUpDown1", "IconArrowUpDown1", "IconArrowUpDown2", "IconArrowUpDown1"],
      sortNames: ["fertilizationdate", "transferdate", "birthdate", "lastbirthon", "name"],
      IconArrowUpDown1: shallowRef(icons.IconArrowUpDown1),
      IconArrowUpDown2: shallowRef(icons.IconArrowUpDown2),
      IconArrowUpDown3: shallowRef(icons.IconArrowUpDown3),
      IconClear: shallowRef(icons.IconClear),
      IconPencil: shallowRef(icons.IconPencil),
      IconAdjustment: shallowRef(icons.IconAdjustment),
      IconMagnifyingGlass: shallowRef(icons.IconMagnifyingGlass),
      IconCalendar: shallowRef(icons.IconCalendar),
      IconPlus: shallowRef(icons.IconPlus),
      IconPlusCircle: shallowRef(icons.IconPlusCircle),
      IconTrash: shallowRef(icons.IconTrash),
      IconCheck: shallowRef(icons.IconCheck),
      IconArrowDownBold: shallowRef(icons.IconArrowDownBold),
      IconArrowUpBold: shallowRef(icons.IconArrowUpBold),
      return_history: false,
      maxLength: ConstParam.maxLength,
      loadingImg: false,
      // 
      pregnancy_term: ConstParam.pregnancy_term,
      // 種雄牛データ
      bullData: {},
      // 受精卵データ
      eggData: {},
      // 農家データ
      farmerData: {},
      // ダイアログ変数
      moCowSelectDialog: false,
      moCowSelect: [],
      calfCowSelectDialog: false,
      calfCowSelect: [],
      cowSelectFilterDialog: false,
      transferDialog: false,
      inseminatorDialog: false,
      eggNameDialog: false,
      eggViewDialog: false,
      bullViewDialog: false,
      bullNameDialog: false,
      insTransfer: "",
      insInseminator: "",
      selectIndex: "",
      dialogImageVisible: false,
      ImageDialogRow: {},
      // フィルター変数
      icon_color: colorNormal,
      filter_emptywomb: false,
      filter_inseminated: false,
      filter_pregnant: false,
      filter_transfered: false,
      filter_adultcattle: false,
      filter_calf: false,
      filter_shipping: false,
      filter_deathdisuse: false,
      filter_status_noset: false,
      filter_cow: false,
      filter_bull: false,
      filter_sex_noset: false,
      filter_wagyu: false,
      filter_holstein: false,
      filter_f1: false,
      filter_redcow: false,
      filter_breed_noset: false,
      filter_in_barn: false,
      // フィルターワーク
      dialog_emptywomb: false,
      dialog_inseminated: false,
      dialog_pregnant: false,
      dialog_transfered: false,
      dialog_adultcattle: false,
      dialog_calf: false,
      dialog_shipping: false,
      dialog_deathdisuse: false,
      dialog_status_noset: false,
      dialog_cow: false,
      dialog_bull: false,
      dialog_sex_noset: false,
      dialog_wagyu: false,
      dialog_holstein: false,
      dialog_f1: false,
      dialog_redcow: false,
      dialog_breed_noset: false,
      dialog_in_barn: false,
      // 個体情報
      cow_image: "",
      cow_id: "",
      cow_name: "",
      cow_number: "",
      cow_birth: "",
      cow_birth_jpn: "",
      cow_breed: "",
      cow_sex: "",
      cow_status: "",
      birth_count: "0",
      // 個体情報 編集用
      cow_breed_edit: "",
      cow_sex_edit: "",
      cow_status_edit: "",
      // 最終出産情報
      estrus_on: "",
      bull_code: "",
      inseminate_on: "",
      inseminate_on_info: "",
      inseminator: "",
      egg: "",
      transfer_on: "",
      transfer_on_info: "",
      transfer: "",
      pregnancy_on: "",
      birth_reserve_date: "",
      birth_on_status: "",
      birth_on: "",
      is_birth: "出産",
      is_birth_date: "",
      amnion: "する",
      // 出産履歴情報
      estrus_on_array: [],
      inseminate_date_name_array: [],
      transfer_date_name_array: [],
      pregnancy_date_flg_array: [],
      // 血統
      fa: "",
      fa_fa: "",
      fa_mo: "",
      fa_fa_fa: "",
      fa_mo_fa: "",
      mo: "",
      mo_fa: "",
      mo_mo: "",
      mo_fa_fa: "",
      mo_mo_fa: "",
      // 出産情報
      maxBirthHistory: "",
      estrus_count: 1,
      inseminate_count: 1,
      pregnancy_count: 1,
      birth_id: "",
      birth_estrus_on: [],
      birth_inseminate: [],
      birth_pregnancy: [],
      birth_birth_reserve_date: "",
      birth_birth: {},
      calf_name: "",
      calf_name_info: "",
      calf_number: "",
      calf_id: "",
      birth_is_lick_amnion: "する",
      // 牛選択・編集
      cow_select: "",
      cow_edit: false,
      cow_history: false,
      // アラート
      alertsData: [],
      alertsTable: [],
      // 変換テーブル
      alert_message: ConstParam.alert_message,
      // その他
      select_history: "",
      bullNameSelect: [],
      bullNameSelectList: [],
      eggNameSelect: [],
      eggNameSelectList: [],
      barnsData: {},
      cowsData: {},
      birthData: {},
      transfer_select: [],
      transfer_select_list: [],
      inseminator_select: [],
      inseminator_select_list: [],
      orgTableData: [],
      tableData: [],
      tableBirthData: [],
      cow_kinds: ConstParam.cow_kinds,
      cow_sexs: ConstParam.cow_sexs,
      cow_status_kinds: ConstParam.cow_status_kinds,
      cow_status_select: ConstParam.cow_status_select,
      cow_kinds_select: ConstParam.cow_kinds_select,
      cow_sexs_select: ConstParam.cow_sexs_select,
      cow_amnions_select: ConstParam.cow_amnions_select,
      cow_birth_select: ConstParam.cow_birth_select,
      cow_pregnancy_select: ConstParam.cow_pregnancy_select,
      search_text: "",
      search_text_maxlength: ConstParam.number_maxLength,
      search_text_placeholder: ConstParam.search_text_placeholder_number,
      isSearchNumber: true,
      // ===== 以降固定 ====
      isAdmin: false,
      cow_menu_radio: "",
      loading: false,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false
      // ==================
    }
  },
  methods: {
    setSortParam() {
      for (let idx = 0; idx < this.sortLevel.length; idx++) {
        if (this.sortLevel[idx] > 0) {
          this.sortIndex = idx
          if (this.sortLevel[idx] == 1) {
            // 降順ソート
            this.sortCowsAscending = true
          } else {
            // 昇順ソート
            this.sortCowsAscending = false
          }
          // ソート項目設定
          this.sortOrder = this.cowSortKey[idx]
        }
        this.sortIcons[idx] = this.sortIconNames[this.sortLevel[idx]]
      }
    },
    setFilterParam() {
      // ソート条件
      this.sortLevel = structuredClone(this.filterParam.sortParam)
      // 検索条件
      this.isSearchNumber = this.filterParam.searchMode
      this.search_text = this.filterParam.searchText
      // フィルター設定
      this.filter_emptywomb = this.filterParam.filter_emptywomb
      this.filter_inseminated = this.filterParam.filter_inseminated
      this.filter_pregnant = this.filterParam.filter_pregnant
      this.filter_transfered = this.filterParam.filter_transfered
      this.filter_adultcattle = this.filterParam.filter_adultcattle
      this.filter_calf = this.filterParam.filter_calf
      this.filter_shipping = this.filterParam.filter_shipping
      this.filter_deathdisuse = this.filterParam.filter_deathdisuse
      this.filter_status_noset = this.filterParam.filter_status_noset
      this.filter_cow = this.filterParam.filter_cow
      this.filter_bull = this.filterParam.filter_bull
      this.filter_sex_noset = this.filterParam.filter_sex_noset
      this.filter_wagyu = this.filterParam.filter_wagyu
      this.filter_holstein = this.filterParam.filter_holstein
      this.filter_f1 = this.filterParam.filter_f1
      this.filter_redcow = this.filterParam.filter_redcow
      this.filter_breed_noset = this.filterParam.filter_breed_noset
      this.filter_in_barn = this.filterParam.filter_in_barn
    },
    saveFilterParam() {
      let tempParam = {
        save: true,
        sortParam: this.sortLevel,
        searchMode: this.isSearchNumber,
        searchText: this.search_text,
        filter_emptywomb: this.filter_emptywomb,
        filter_inseminated: this.filter_inseminated,
        filter_pregnant: this.filter_pregnant,
        filter_transfered: this.filter_transfered,
        filter_adultcattle: this.filter_adultcattle,
        filter_calf: this.filter_calf,
        filter_shipping: this.filter_shipping,
        filter_deathdisuse: this.filter_deathdisuse,
        filter_status_noset: this.filter_status_noset,
        filter_cow: this.filter_cow,
        filter_bull: this.filter_bull,
        filter_sex_noset: this.filter_sex_noset,
        filter_wagyu: this.filter_wagyu,
        filter_holstein: this.filter_holstein,
        filter_f1: this.filter_f1,
        filter_redcow: this.filter_redcow,
        filter_breed_noset: this.filter_breed_noset,
        filter_in_barn: this.filter_in_barn
      }
      this.$store.commit('setCowManageFilterParam', tempParam)
    },
    handleCommand(command) {
      this.search_text = command
      this.filterUpdate()
    },
    setSuggestionsDatas(farmer) {
      this.suggestionsDatas.cows_name = []
      this.suggestionsDatas.cows_number = []
      // サジェスチョンデータの準備
      if (farmer && 'cow_names' in farmer) {
        this.suggestionsDatas.cows_name = structuredClone(farmer.cow_names)
      }
      if (farmer && 'cow_numbers' in farmer) {
        this.suggestionsDatas.cows_number = structuredClone(farmer.cow_numbers)
      }
      // cowsName.sort((a, b) => a - b)
      // cowsNumber.sort((a, b) => a - b)
      this.setSuggestionsData()
    },
    setSuggestionsData() {
      this.suggestionsData = []
      let tempCowsData = []
      let tempData = []
      if (this.isSearchNumber) {
        tempData = structuredClone(this.suggestionsDatas.cows_number)
      } else {
        tempData = structuredClone(this.suggestionsDatas.cows_name)
      }
      if (this.search_text !== "") {
        tempCowsData = tempData.filter(word => word.indexOf(this.search_text) == 0)
      } else {
        tempCowsData = tempData
      }
      for (let idx = 0; idx < tempCowsData.length; idx++) {
        let tempData = {
          value: tempCowsData[idx],
          label: tempCowsData[idx]
        }
        this.suggestionsData.push(tempData)
      }
    },
    focusOut() {
      let obj = document.activeElement
      if (obj) {
        obj.blur()
      }
    },
    calendarOpen() {
      if (this.calendarOpenEnabled) {
        this.$refs.cowBirth.focus()
      }
      this.calendarOpenEnabled = true
    },
    setTimer() {
      let timeOut = 100; // 100ms毎
      this.interval_id = setInterval(function () {
        this.getPedigreeLineInfo();
        this.redrawTimer--;
        if (this.redrawTimer == 0) {
          this.fatherCanvasEnv = true
          this.motherCanvasEnv = true
        } else if (this.redrawTimer < 0) {
          this.redrawTimer = 0;
        }
      }.bind(this), timeOut);
    },
    getPedigreeLineInfo() {
      "cow_select !== '' & cow_select !== '新規登録' & !cow_edit & !cow_history"
      if (
        this.cow_select !== '' &&
        this.cow_select !== '新規登録' &&
        !this.cow_edit &&
        !this.cow_history
      ) {
        try {
          let canvasHeightOffset = -16
          let right_side_split = 750
          // 父牛系統
          let f_side_width = document.getElementById('father_cow').clientWidth
          if (f_side_width < right_side_split) {
            this.r_side_split = true
          } else {
            this.r_side_split = false
          }
          this.ffCowHeight = document.getElementById('ff_cow').clientHeight
          this.fmCowHeight = document.getElementById('fm_cow').clientHeight
          let tempFatherDivHeight = this.ffCowHeight + this.fmCowHeight
          if ((tempFatherDivHeight + canvasHeightOffset) != this.fatherCanvasHeight) {
            this.fatherCanvas = null
            this.fatherCanvasEnv = false
            this.fatherCanvasHeight = tempFatherDivHeight + canvasHeightOffset
            this.redrawTimer = 2
          }
          // 母牛系統
          this.mfCowHeight = document.getElementById('mf_cow').clientHeight
          this.mmCowHeight = document.getElementById('mm_cow').clientHeight
          let tempMotherDivHeight = this.mfCowHeight + this.mmCowHeight
          if ((tempMotherDivHeight + canvasHeightOffset) != this.motherCanvasHeight) {
            this.motherCanvas = null
            this.motherCanvasEnv = false
            this.motherCanvasHeight = tempMotherDivHeight + canvasHeightOffset
            this.redrawTimer = 2
          }
        } catch (e) {
          return
        }
      }
    },
    getErrorMessage(res) {
      if (
        'message' in res &&
        'response' in res.message &&
        'data' in res.message.response &&
        'message' in res.message.response.data
      ) {
        return res.message.response.data.message
      } else {
        return ""
      }
    },
    // ==================
    // ダミーデータ登録用
    // ==================
    cowInfoDataEntryDummy: async function () {
      // データのセット
      let num4 = ("000" + this.addNumber).substr(-4, 4)
      let cow_number = "00000" + num4 + "0"
      let cow_name = "高速化テスト_牛_" + num4
      let tempPedigree = {
        "fa": this.fa,
        "fa_fa": this.fa_fa,
        "fa_mo": this.fa_mo,
        "fa_fa_fa": this.fa_fa_fa,
        "fa_mo_fa": this.fa_mo_fa,
        "mo": this.mo,
        "mo_fa": this.mo_fa,
        "mo_mo": this.mo_mo,
        "mo_fa_fa": this.mo_fa_fa,
        "mo_mo_fa": this.mo_mo_fa
      }
      await AWSAPI.addCowBirth(
        this.userData['farmer']['farmer_id'],
        cow_name,
        0,
        "2021-07-01",
        cow_number,
        0,
        0,
        0,
        tempPedigree,
        [],
        [],
        [],
        this.birth_reserve_date,
        { "is_birth": true, "date": "", "calf_name": "", "calf_number": "" },
        null,
        false
      )
        .then((res) => {
          console.log(res)
          this.addFlag = !this.addFlag
        });
    },
    deleteCowDataDummy() {
      AWSAPI.deleteCow(this.tableData[this.deleteIndex].id)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.deleteFlag = !this.deleteFlag
          }
        });
    },
    getAlertMessage(alertIndex) {
      let ret = ""
      let messageIndex = this.alert_message.findIndex(({ alert_index }) => alert_index == alertIndex)
      if (messageIndex != -1) {
        ret = this.alert_message[messageIndex].message_text
      }
      return ret
    },
    // getSortCows start
    pageChange(val) {
      this.sortCowsIndex = val - 1
      if (val > this.sortCowsIndexCount) {
        // 次ページデータ取得
        this.getCowsDataNext()
      } else {
        // 取得済みページ切り替え
        this.cowsData = structuredClone(this.sortCowsListData[this.sortCowsIndex])
      }
    },
    getSortCowsCount() {
      let cowsCount = 0
      for (let idx = 0; idx < this.sortCowsListData.length; idx++) {
        cowsCount += this.sortCowsListData[idx].length
      }
      return cowsCount
    },
    getCowNumberNames: async function () {
      if (this.farmer_id === "") {
        return
      }
      // this.cowNumberNames = {}
      await AWSAPI.getCowNumberNames(
        this.farmer_id
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.cowNumberNames = res.data.data[0];
          }
        });
    },
    getCowsDataFirst() {
      this.loading = true;
      this.tableData = []
      this.getCowsData({}, this.sortOrder, this.sortCowsAscending, this.sortCowsCowInBarn, this.search_text, this.isSearchNumber);
      this.getCowNumberNames()
    },
    getCowsDataNext() {
      if (this.sortCowsListKey != {}) {
        this.loading = true;
        this.tableData = []
        this.getCowsData(this.sortCowsListKey, this.sortOrder, this.sortCowsAscending, this.sortCowsCowInBarn, this.search_text, this.isSearchNumber);
        this.getCowNumberNames()
      }
    },
    getCowsDataUpdate() {
      if (this.sortCowsListKey != {}) {
        this.loading = true;
        this.tableData = []
        this.getCowsDataIndex(this.sortOrder, this.sortCowsAscending, this.sortCowsCowInBarn, this.search_text, this.isSearchNumber);
        this.getCowNumberNames()
      }
    },
    getCowsData: async function (
      start_key, cow_sort, cow_sort_forward, cow_in_barn, cow_search_text, is_number
    ) {
      if (this.farmer_id === "") {
        return
      }
      // フィルタ適用
      let cow_pregnancy_status = []
      if (this.filter_emptywomb) { cow_pregnancy_status.push(0) }
      if (this.filter_inseminated) { cow_pregnancy_status.push(1) }
      if (this.filter_pregnant) { cow_pregnancy_status.push(2) }
      if (this.filter_transfered) { cow_pregnancy_status.push(3) }
      let cow_status = []
      if (this.filter_adultcattle) { cow_status.push(0) }
      if (this.filter_calf) { cow_status.push(1) }
      if (this.filter_shipping) { cow_status.push(2) }
      if (this.filter_deathdisuse) { cow_status.push(3) }
      let cow_status_not_exists = false
      if (this.filter_status_noset) { cow_status_not_exists = true }
      let cow_sex = []
      if (this.filter_cow) { cow_sex.push(0) }
      if (this.filter_bull) { cow_sex.push(1) }
      let cow_sex_not_exists = false
      if (this.filter_sex_noset) { cow_sex_not_exists = true }
      let cow_breed = []
      if (this.filter_wagyu) { cow_breed.push(0) }
      if (this.filter_holstein) { cow_breed.push(1) }
      if (this.filter_f1) { cow_breed.push(2) }
      if (this.filter_redcow) { cow_breed.push(3) }
      let cow_breed_not_exists = false
      if (this.filter_breed_noset) { cow_breed_not_exists = true }
      cow_in_barn = this.filter_in_barn
      // 検索文字列(設定無効なら空白文字列に設定)
      if (!cow_search_text) { cow_search_text = "" }
      // 初回呼び出しかどうか
      if (Object.keys(start_key).length == 0) {
        // 初回呼び出し
        this.sortCowsIndexCount = 0
        this.sortCowsTotalCount = 0
        this.sortCowsIndex = 0
        this.sortCowsListKey = {}
        this.sortCowsListKeyArray = []
        this.sortCowsListCount = []
        this.sortCowsListData = []
      }
      await AWSAPI.getSortCows(
        this.farmer_id,
        start_key,
        cow_sort,
        cow_sort_forward,
        cow_pregnancy_status,
        cow_status,
        cow_status_not_exists,
        cow_sex,
        cow_sex_not_exists,
        cow_breed,
        cow_breed_not_exists,
        cow_in_barn,
        cow_search_text,
        is_number
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.sortCowsData = res['data'];
            this.loading = false
          }
        });
    },
    getCowsDataIndex: async function (
      cow_sort, cow_sort_forward, cow_in_barn, cow_search_text, is_number
    ) {
      if (this.farmer_id === "") {
        return
      }
      // フィルタ適用
      let cow_pregnancy_status = []
      if (this.filter_emptywomb) { cow_pregnancy_status.push(0) }
      if (this.filter_inseminated) { cow_pregnancy_status.push(1) }
      if (this.filter_pregnant) { cow_pregnancy_status.push(2) }
      if (this.filter_transfered) { cow_pregnancy_status.push(3) }
      let cow_status = []
      if (this.filter_adultcattle) { cow_status.push(0) }
      if (this.filter_calf) { cow_status.push(1) }
      if (this.filter_shipping) { cow_status.push(2) }
      if (this.filter_deathdisuse) { cow_status.push(3) }
      let cow_status_not_exists = false
      if (this.filter_status_noset) { cow_status_not_exists = true }
      let cow_sex = []
      if (this.filter_cow) { cow_sex.push(0) }
      if (this.filter_bull) { cow_sex.push(1) }
      let cow_sex_not_exists = false
      if (this.filter_sex_noset) { cow_sex_not_exists = true }
      let cow_breed = []
      if (this.filter_wagyu) { cow_breed.push(0) }
      if (this.filter_holstein) { cow_breed.push(1) }
      if (this.filter_f1) { cow_breed.push(2) }
      if (this.filter_redcow) { cow_breed.push(3) }
      let cow_breed_not_exists = false
      if (this.filter_breed_noset) { cow_breed_not_exists = true }
      cow_in_barn = this.filter_in_barn
      // 検索文字列(設定無効なら空白文字列に設定)
      if (!cow_search_text) { cow_search_text = "" }
      // キーの有無
      let start_key = {}
      let tempIndex = this.sortCowsIndex - 1
      if (tempIndex >= 0) {
        if (Object.keys(this.sortCowsListKeyArray[tempIndex]).length != 0) {
          start_key = structuredClone(this.sortCowsListKeyArray[tempIndex])
        }
      }
      await AWSAPI.getSortCows(
        this.farmer_id,
        start_key,
        cow_sort,
        cow_sort_forward,
        cow_pregnancy_status,
        cow_status,
        cow_status_not_exists,
        cow_sex,
        cow_sex_not_exists,
        cow_breed,
        cow_breed_not_exists,
        cow_in_barn,
        cow_search_text,
        is_number
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.updateSortCowsData = res['data'];
            this.loading = false
          }
        });
    },
    // getSortCows end
    after_0_year(val) {
      const inputDateStr = dayjs(val).format('YYYY-MM-DD');
      const nowDateStr = dayjs(new Date()).format('YYYY-MM-DD');
      return !(inputDateStr <= nowDateStr);
    },
    after_1_year(val) {
      const inputDateStr = dayjs(val).format('YYYY-MM-DD');
      const targetDateStr = dayjs(new Date()).add(1, 'y').subtract(1, 'd').format('YYYY-MM-DD');
      return !(inputDateStr <= targetDateStr);
    },
    after_2_year(val) {
      const inputDateStr = dayjs(val).format('YYYY-MM-DD');
      const targetDateStr = dayjs(new Date()).add(2, 'y').subtract(1, 'd').format('YYYY-MM-DD');
      return !(inputDateStr <= targetDateStr);
    },
    calcHeaderSpace(spacesize) {
      this.headerWidth = spacesize;
    },
    sortSetting(index) {
      this.sortIndex = index;
      this.tableUserData = [];
      for (let idx = 0; idx < this.sortLevel.length; idx++) {
        if (idx == index) {
          this.sortLevel[idx] = (this.sortLevel[idx] + 1) % 3;
          if (this.sortLevel[idx] == 0) {
            this.sortLevel[idx] = 1
          }
        } else {
          this.sortLevel[idx] = 0;
        }
        this.sortIcons[idx] = this.sortIconNames[this.sortLevel[idx]];
      }
      // フィルター再適用
      this.filterUpdate();
    },
    validate() {
      if (this.isSearchNumber) {
        this.search_text = this.search_text.replace(/\D/g, '')
      }
      this.setSuggestionsData()
    },
    calcBirthReserveDate() {
      // 出産履歴編集時のチェック
      if (this.cow_history && this.select_history !== this.maxBirthHistory) {
        // 最新の履歴以外は自動計算対象外
        return;
      }
      // 算出条件確認
      let biLength = this.birth_inseminate.length;
      let bpDate = "";
      if (this.birth_pregnancy.length > 0) {
        let idx = this.birth_pregnancy.length - 1;
        if (this.birth_pregnancy[idx].is_pregnancy === this.cow_pregnancy_select[0].kind) {
          bpDate = this.birth_pregnancy[idx].date;
        }
      }
      if (
        // 牛の種類が未選択でない(牛の種類が未選択で編集出来ない仕様なので判定は省略) 
        // 人工授精・受精卵移植が存在し、日付が入力されていること
        // 妊娠鑑定日が妊娠かつ有効であること(bpDateに日付がセットされていること)
        (biLength > 0 && this.birth_inseminate[biLength - 1].date !== '') &&
        bpDate !== ""
      ) {
        // 出産予定日の算出
        let target_date = ""
        if (this.birth_inseminate[biLength - 1].method == 0) {
          target_date = dayjs(this.birth_inseminate[biLength - 1].date).add(this.pregnancy_term, 'd').format('YYYY-MM-DD');
        } else {
          target_date = dayjs(this.birth_inseminate[biLength - 1].date).add(this.pregnancy_term - 7, 'd').format('YYYY-MM-DD');
        }
        this.birth_reserve_date = target_date;
      }
    },
    selectedMoCow(moCow) {
      // 母牛血統情報のセット
      if ("pedigree" in moCow) {
        this.mo = moCow["cow_name"];
        this.mo_fa = moCow["pedigree"]["fa"];
        this.mo_mo = moCow["pedigree"]["mo"];
        this.mo_fa_fa = moCow["pedigree"]["fa_fa"];
        this.mo_mo_fa = moCow["pedigree"]["mo_fa"];
      }
      this.dialogClose('cowDialog');
    },
    selectedCalfCow(calfCow) {
      // 子牛情報のセット
      this.calf_name = calfCow["cow_name"];
      this.calf_number = calfCow["cow_number"];
      this.calf_id = calfCow["cow_id"];
      this.is_birth_date = calfCow["cow_birth"] === "" ? this.is_birth_date : calfCow["cow_birth"];
      // 解除ボタン有効化
      this.numberView = true;
      this.dialogClose('calfDialog');
    },
    moCowSelectDialogView() {
      this.moCowSelectDialog = true;
    },
    calfCowSelectDialogView() {
      this.calfCowSelectDialog = true;
    },
    calfCowDelete() {
      // 子牛情報の解除
      this.calf_name = "";
      this.calf_number = "";
      this.calf_id = "";
      this.is_birth_date = "";
      // 解除ボタン無効
      this.numberView = false;
    },
    change_radio_button(binseminate) {
      binseminate.method = parseInt(binseminate.method_str);
    },
    dialogClose(dialogName) {
      if (dialogName === "dialogImageVisible") {
        this.loadingImg = false;
        this.dialogImageVisible = false;
      } else if (dialogName === "bullDialog") {
        this.bullViewDialog = false;
      } else if (dialogName === "eggDialog") {
        this.eggViewDialog = false;
      } else if (dialogName === "cowDialog") {
        this.moCowSelectDialog = false;
      } else if (dialogName === "calfDialog") {
        this.calfCowSelectDialog = false;
      }
    },
    ImageDialogView(row) {
      this.ImageDialogRow = row;
      this.loadingImg = true;
      this.dialogImageVisible = true;
    },
    tableSelect(selection) {
      this.select_alert = selection;
    },
    cow_open() {
      this.numberView = false;
      this.cow_edit = true;
      this.get_birth_data(this.cow_select);
    },
    history_open() {
      this.cow_history = true;
      this.get_birth_data(this.cow_select);
    },
    clickTransferSelect(value) {
      this.transferListSet(this.birth_inseminate[value].transfer);
      this.transferDialog = true;
      this.selectIndex = value;
    },
    clickTransfer(selTransfer) {
      this.birth_inseminate[this.selectIndex]['transfer'] = selTransfer;
      this.transferDialog = false;
    },
    clickAddTransfer() {
      if (this.insTransfer === "") {
        return;
      }
      let message = "移植師『" + this.insTransfer + "』を追加しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '登録',
        cancelButtonText: 'キャンセル'
      }).then(() => {
        this.update_farmer_transfer(this.insTransfer, "");
        this.insTransfer = "";
      }).catch(() => {
        return
      });
    },
    clickDelTransfer(delTransfer) {
      let message = "移植師『" + delTransfer + "』を削除しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.update_farmer_transfer("", delTransfer);
      }).catch(() => {
        return
      });
    },
    clickInseminatorSelect(value) {
      this.inseminatorListSet(this.birth_inseminate[value].inseminator);
      this.inseminatorDialog = true;
      this.selectIndex = value;
    },
    clickInseminator(selInseminator) {
      this.birth_inseminate[this.selectIndex]['inseminator'] = selInseminator;
      this.inseminatorDialog = false;
    },
    clickAddInseminator() {
      if (this.insInseminator === "") {
        return;
      }
      let message = "人工授精師『" + this.insInseminator + "』を追加しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '登録',
        cancelButtonText: 'キャンセル'
      }).then(() => {
        this.update_farmer_inseminator(this.insInseminator, "");
        this.insInseminator = "";
      });
    },
    clickDelInseminator(delInseminator) {
      let message = "人工授精師『" + delInseminator + "』を削除しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.update_farmer_inseminator("", delInseminator);
      }).catch(() => {
        return
      });
    },
    clickBullNameSelect(value) {
      this.bullNameSetList((this.birth_inseminate[value].bull_name !== "") ? this.birth_inseminate[value].bull_id : "");
      this.bullNameDialog = true;
      this.selectIndex = value;
    },
    clickBullName(selBullName, selBullId) {
      this.birth_inseminate[this.selectIndex]['bull_name'] = selBullName;
      this.birth_inseminate[this.selectIndex]['bull_id'] = selBullId;
      this.bullNameDialog = false;
    },
    clickAddBullName() {
      this.bullViewDialog = true;
    },
    clickDelBullName(delBullName, delBullId) {
      let message = "種雄牛名『" + delBullName + "』を削除しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.delete_bull(delBullId);
      }).catch(() => {
        return
      });
    },
    clickEggNameSelect(value) {
      this.eggNameSetList((this.birth_inseminate[value].egg_name !== "") ? this.birth_inseminate[value].egg.egg_id : "");
      this.eggNameDialog = true;
      this.selectIndex = value;
    },
    clickEggName(selEggName, selEggId) {
      let fa_name = "";
      let mo_name = "";
      if (selEggName.indexOf('/') != -1) {
        let tempName = selEggName.split('/');
        fa_name = tempName[0];
        mo_name = tempName[1];
      }
      this.birth_inseminate[this.selectIndex]['egg_name'] = selEggName;
      this.birth_inseminate[this.selectIndex]['fa_name'] = fa_name;
      this.birth_inseminate[this.selectIndex]['mo_name'] = mo_name;
      if ("egg" in this.birth_inseminate[this.selectIndex]) {
        this.birth_inseminate[this.selectIndex]['egg']['egg_id'] = selEggId;
      } else {
        this.birth_inseminate[this.selectIndex]['egg'] = { egg_id: selEggId };
      }
      this.eggNameDialog = false;
    },
    clickAddEggName() {
      this.eggViewDialog = true;
    },
    clickDelEggName(delEggName, delEggId) {
      let message = "受精卵『" + delEggName + "』を削除します。よろしいですか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.delete_egg(delEggId);
      }).catch(() => {
        return
      });
    },
    update_farmer_transfer: async function (addTransfer, delTransfer) {
      this.loading = true;
      await AWSAPI.updateFarmerTransfer(this.userData['farmer']['farmer_id'], addTransfer, delTransfer)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            if (addTransfer !== "") {
              this.viewMessage("移植師を追加しました。", "success");
              this.birth_inseminate[this.selectIndex].transfer = addTransfer;
              this.transferDialog = false;
            }
            if (delTransfer !== "") {
              this.viewMessage("移植師を削除しました。", "success");
              for (let idx = 0; idx < this.transfer_select_list.length; idx++) {
                if (this.transfer_select_list[idx].transfer === delTransfer) {
                  this.transfer_select_list.splice(idx, 1)
                  break
                }
              }
              this.birth_inseminate[this.selectIndex].transfer = ""
            }
          }
          this.get_farmer_data()
        });
    },
    update_farmer_inseminator: async function (addInseminator, delInseminator) {
      this.loading = true;
      await AWSAPI.updateFarmerInseminator(this.userData['farmer']['farmer_id'], addInseminator, delInseminator)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            if (addInseminator !== "") {
              this.viewMessage("人工授精師を追加しました。", "success");
              this.birth_inseminate[this.selectIndex].inseminator = addInseminator;
              this.inseminatorDialog = false;
            }
            if (delInseminator !== "") {
              this.viewMessage("人工授精師を削除しました。", "success");
              for (let idx = 0; idx < this.inseminator_select_list.length; idx++) {
                if (this.inseminator_select_list[idx].inseminator === delInseminator) {
                  this.inseminator_select_list.splice(idx, 1)
                  break
                }
              }
              this.birth_inseminate[this.selectIndex].inseminator = "";
            }
          }
          this.get_farmer_data()
        });
    },
    delete_bull: async function (delBullCode) {
      this.loading = true;
      await AWSAPI.deleteBull(delBullCode)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage("種雄牛を削除しました。", "success");
            for (let idx = 0; idx < this.bullNameSelectList.length; idx++) {
              if (this.bullNameSelectList[idx].bull_id === delBullCode) {
                this.bullNameSelectList.splice(idx, 1)
                break
              }
            }
            this.birth_inseminate[this.selectIndex].bull_name = ""
          }
          this.get_bull_data()
        });
    },
    delete_egg: async function (delEggCode) {
      this.loading = true;
      await AWSAPI.deleteEgg(delEggCode)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage("受精卵を削除しました。", "success");
            for (let idx = 0; idx < this.eggNameSelectList.length; idx++) {
              if (this.eggNameSelectList[idx].egg_id === delEggCode) {
                this.eggNameSelectList.splice(idx, 1)
                break
              }
            }
            this.birth_inseminate[this.selectIndex].egg_name = ""
          }
          this.get_egg_data()
        });
    },
    newEntry() {
      // 新規登録
      this.isAbbreviationDisplay = true
      this.cow_select = "新規登録"
      this.cowInfoDataSet(this.cow_select)
      this.cow_edit = true
    },
    editCancel() {
      // 変更キャンセル
      this.cow_edit = false;
      if (this.cow_select !== "新規登録") {
        this.cowInfoDataSet(this.cow_select);
      } else {
        this.cow_select = "";
      }
    },
    filterUpdate() {
      this.saveFilterParam()
      let envFilter = this.filter_emptywomb ||
        this.filter_inseminated ||
        this.filter_pregnant ||
        this.filter_transfered ||
        this.filter_adultcattle ||
        this.filter_calf ||
        this.filter_shipping ||
        this.filter_deathdisuse ||
        this.filter_status_noset ||
        this.filter_cow ||
        this.filter_bull ||
        this.filter_sex_noset ||
        this.filter_wagyu ||
        this.filter_holstein ||
        this.filter_f1 ||
        this.filter_redcow ||
        this.filter_breed_noset ||
        this.filter_in_barn;
      if (envFilter) {
        this.icon_color = colorYellow;
      } else {
        this.icon_color = colorNormal;
      }
      // アイテムソート指定
      for (let idx = 0; idx < this.sortLevel.length; idx++) {
        if (this.sortLevel[idx] > 0) {
          if (this.sortLevel[idx] == 1) {
            // 降順ソート
            this.sortCowsAscending = true
          } else {
            // 昇順ソート
            this.sortCowsAscending = false
          }
          // ソート項目設定
          this.sortOrder = this.cowSortKey[idx]
        }
      }
      this.getCowsDataFirst()
    },
    filterDisable(filterNumber) {
      if (filterNumber == 0) { this.filter_emptywomb = false; }
      else if (filterNumber == 1) { this.filter_inseminated = false; }
      else if (filterNumber == 2) { this.filter_pregnant = false; }
      else if (filterNumber == 3) { this.filter_transfered = false; }
      else if (filterNumber == 10) { this.filter_adultcattle = false; }
      else if (filterNumber == 11) { this.filter_calf = false; }
      else if (filterNumber == 12) { this.filter_shipping = false; }
      else if (filterNumber == 13) { this.filter_deathdisuse = false; }
      else if (filterNumber == 14) { this.filter_status_noset = false; }
      else if (filterNumber == 20) { this.filter_cow = false; }
      else if (filterNumber == 21) { this.filter_bull = false; }
      else if (filterNumber == 22) { this.filter_sex_noset = false; }
      else if (filterNumber == 30) { this.filter_wagyu = false; }
      else if (filterNumber == 31) { this.filter_holstein = false; }
      else if (filterNumber == 32) { this.filter_f1 = false; }
      else if (filterNumber == 33) { this.filter_redcow = false; }
      else if (filterNumber == 34) { this.filter_breed_noset = false; }
      else if (filterNumber == 40) { this.filter_in_barn = false; }
      // フィルター再適用
      this.filterUpdate();
    },
    filterAllReset() {
      this.search_text = ""
      this.filterReset()
      // フィルター再適用
      this.filterUpdate();
    },
    filterReset() {
      this.dialog_emptywomb = false;
      this.dialog_inseminated = false;
      this.dialog_pregnant = false;
      this.dialog_transfered = false;
      this.dialog_adultcattle = false;
      this.dialog_calf = false;
      this.dialog_shipping = false;
      this.dialog_deathdisuse = false;
      this.dialog_status_noset = false;
      this.dialog_cow = false;
      this.dialog_bull = false;
      this.dialog_sex_noset = false;
      this.dialog_wagyu = false;
      this.dialog_holstein = false;
      this.dialog_f1 = false;
      this.dialog_redcow = false;
      this.dialog_breed_noset = false;
      this.dialog_in_barn = false;
      // フィルター設定内容の反映
      this.filter_emptywomb = this.dialog_emptywomb;
      this.filter_inseminated = this.dialog_inseminated;
      this.filter_pregnant = this.dialog_pregnant;
      this.filter_transfered = this.dialog_transfered;
      this.filter_adultcattle = this.dialog_adultcattle;
      this.filter_calf = this.dialog_calf;
      this.filter_shipping = this.dialog_shipping;
      this.filter_deathdisuse = this.dialog_deathdisuse;
      this.filter_status_noset = this.dialog_status_noset;
      this.filter_cow = this.dialog_cow;
      this.filter_bull = this.dialog_bull;
      this.filter_sex_noset = this.dialog_sex_noset;
      this.filter_wagyu = this.dialog_wagyu;
      this.filter_holstein = this.dialog_holstein;
      this.filter_f1 = this.dialog_f1;
      this.filter_redcow = this.dialog_redcow;
      this.filter_breed_noset = this.dialog_breed_noset;
      this.filter_in_barn = this.dialog_in_barn;
      // アイコンカラーのリセット
      this.icon_color = colorNormal;
    },
    filterClear() {
      this.dialog_emptywomb = false;
      this.dialog_inseminated = false;
      this.dialog_pregnant = false;
      this.dialog_transfered = false;
      this.dialog_adultcattle = false;
      this.dialog_calf = false;
      this.dialog_shipping = false;
      this.dialog_deathdisuse = false;
      this.dialog_status_noset = false;
      this.dialog_cow = false;
      this.dialog_bull = false;
      this.dialog_sex_noset = false;
      this.dialog_wagyu = false;
      this.dialog_holstein = false;
      this.dialog_f1 = false;
      this.dialog_redcow = false;
      this.dialog_breed_noset = false;
      this.dialog_in_barn = false;
      // フィルター再適用
      this.filterUpdate();
    },
    openDialog() {
      // フィルター設定内容の複写
      this.dialog_emptywomb = this.filter_emptywomb;
      this.dialog_inseminated = this.filter_inseminated;
      this.dialog_pregnant = this.filter_pregnant;
      this.dialog_transfered = this.filter_transfered;
      this.dialog_adultcattle = this.filter_adultcattle;
      this.dialog_calf = this.filter_calf;
      this.dialog_shipping = this.filter_shipping;
      this.dialog_deathdisuse = this.filter_deathdisuse;
      this.dialog_status_noset = this.filter_status_noset;
      this.dialog_cow = this.filter_cow;
      this.dialog_bull = this.filter_bull;
      this.dialog_sex_noset = this.filter_sex_noset;
      this.dialog_wagyu = this.filter_wagyu;
      this.dialog_holstein = this.filter_holstein;
      this.dialog_f1 = this.filter_f1;
      this.dialog_redcow = this.filter_redcow;
      this.dialog_breed_noset = this.filter_breed_noset;
      this.dialog_in_barn = this.filter_in_barn;
      // ダイアログ・オープン
      this.cowSelectFilterDialog = true;
    },
    setFilter() {
      // フィルター設定内容の反映
      this.filter_emptywomb = this.dialog_emptywomb;
      this.filter_inseminated = this.dialog_inseminated;
      this.filter_pregnant = this.dialog_pregnant;
      this.filter_transfered = this.dialog_transfered;
      this.filter_adultcattle = this.dialog_adultcattle;
      this.filter_calf = this.dialog_calf;
      this.filter_shipping = this.dialog_shipping;
      this.filter_deathdisuse = this.dialog_deathdisuse;
      this.filter_status_noset = this.dialog_status_noset;
      this.filter_cow = this.dialog_cow;
      this.filter_bull = this.dialog_bull;
      this.filter_sex_noset = this.dialog_sex_noset;
      this.filter_wagyu = this.dialog_wagyu;
      this.filter_holstein = this.dialog_holstein;
      this.filter_f1 = this.dialog_f1;
      this.filter_redcow = this.dialog_redcow;
      this.filter_breed_noset = this.dialog_breed_noset;
      this.filter_in_barn = this.dialog_in_barn;
      // ダイアログ・クローズ
      this.cowSelectFilterDialog = false;
      // フィルター再適用
      this.filterUpdate();
    },
    searchText() {
      // 文字列検索
      this.filterUpdate();
    },
    selectCowInfo(val) {
      this.isAbbreviationDisplay = true
      this.cow_select = val['id']
      this.loading = true
      this.fatherCanvasEnv = false
      this.motherCanvasEnv = false
      this.fatherCanvasHeight = 66
      this.motherCanvasHeight = 66
      this.getCowsDataUpdate()
      this.get_birth_data(this.cow_select)
      this.get_calf_alerts_data(this.cow_select)
    },
    get_bull_data: async function () {
      this.loading = true;
      await AWSAPI.getBulls(this.userData['farmer']['farmer_id'])
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.bullData = res['data']['data'];
          }
        });
    },
    get_egg_data: async function () {
      this.loading = true;
      await AWSAPI.getEggs(this.userData['farmer']['farmer_id'])
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.eggData = res['data']['data'];
          }
        });
    },
    get_farmer_data: async function () {
      this.loading = true;
      await AWSAPI.getFarmer(this.userData['farmer']['farmer_id'])
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.farmerData = res['data']['data'];
          }
        });
    },
    bullNameSet(bulls_data) {
      this.bullNameSelect = [];
      try {
        for (let idx = 0; idx < bulls_data.length; idx++) {
          let tempBullName = {
            "id": idx,
            "bull_id": bulls_data[idx]["bull_id"],
            "bull_name": bulls_data[idx]["bull_name"],
            "visible": false
          }
          this.bullNameSelect.push(tempBullName);
        }
      } catch (e) {
        console.log(e);
      }
    },
    bullNameSetList(bull_id) {
      this.bullNameSelectList = [];
      try {
        for (let idx = 0; idx < this.bullNameSelect.length; idx++) {
          let tempSelected = 1;
          if (bull_id !== "" && this.bullNameSelect[idx].bull_id === bull_id) {
            tempSelected = 0;
          }
          let tempBullName = {
            "id": idx,
            "bull_id": this.bullNameSelect[idx].bull_id,
            "bull_name": this.bullNameSelect[idx].bull_name,
            "visible": this.bullNameSelect[idx].visible,
            "selected": tempSelected
          }
          this.bullNameSelectList.push(tempBullName);
        }
      } catch (e) {
        console.log(e);
      }
    },
    eggNameSet(eggs_data) {
      this.eggNameSelect = [];
      try {
        for (let idx = 0; idx < eggs_data.length; idx++) {
          let tempEggName = {
            "id": idx,
            "egg_id": eggs_data[idx]["egg_id"],
            "egg_name": eggs_data[idx]["fa_name"] + "/" + eggs_data[idx]["mo_name"],
            "visible": false
          }
          this.eggNameSelect.push(tempEggName);
        }
      } catch (e) {
        console.log(e);
      }
    },
    eggNameSetList(egg_id) {
      this.eggNameSelectList = [];
      try {
        for (let idx = 0; idx < this.eggNameSelect.length; idx++) {
          let tempSelected = 1;
          if (egg_id !== "" && this.eggNameSelect[idx].egg_id === egg_id) {
            tempSelected = 0;
          }
          let tempEggName = {
            "id": idx,
            "egg_id": this.eggNameSelect[idx].egg_id,
            "egg_name": this.eggNameSelect[idx].egg_name,
            "visible": this.eggNameSelect[idx].visible,
            "selected": tempSelected
          }
          this.eggNameSelectList.push(tempEggName);
        }
      } catch (e) {
        console.log(e);
      }
    },
    transferSet(farmer_data) {
      this.transfer_select = [];
      try {
        for (let idx = 0; idx < farmer_data["transfer"].length; idx++) {
          let tempInseminator = {
            "id": idx,
            "transfer": farmer_data["transfer"][idx],
            "visible": false
          }
          this.transfer_select.push(tempInseminator);
        }
      } catch (e) {
        console.log(e);
      }
    },
    transferListSet(transfer_name) {
      this.transfer_select_list = [];
      try {
        for (let idx = 0; idx < this.transfer_select.length; idx++) {
          let tempSelected = 1;
          if (transfer_name !== "" && this.transfer_select[idx].transfer === transfer_name) {
            tempSelected = 0;
          }
          let tempInseminator = {
            "id": idx,
            "transfer": this.transfer_select[idx].transfer,
            "visible": this.transfer_select[idx].visible,
            "selected": tempSelected
          }
          this.transfer_select_list.push(tempInseminator);
        }
      } catch (e) {
        console.log(e);
      }
    },
    inseminatorSet(farmer_data) {
      this.inseminator_select = [];
      try {
        for (let idx = 0; idx < farmer_data["inseminator"].length; idx++) {
          let tempInseminator = {
            "id": idx,
            "inseminator": farmer_data["inseminator"][idx],
            "visible": false
          }
          this.inseminator_select.push(tempInseminator);
        }
      } catch (e) {
        console.log(e);
      }
    },
    inseminatorListSet(inseminator_name) {
      this.inseminator_select_list = [];
      try {
        for (let idx = 0; idx < this.inseminator_select.length; idx++) {
          let tempSelected = 1;
          if (inseminator_name !== "" && this.inseminator_select[idx].inseminator === inseminator_name) {
            tempSelected = 0;
          }
          let tempInseminator = {
            "id": idx,
            "inseminator": this.inseminator_select[idx].inseminator,
            "visible": this.inseminator_select[idx].visible,
            "selected": tempSelected
          }
          this.inseminator_select_list.push(tempInseminator);
        }
      } catch (e) {
        console.log(e);
      }
    },
    get_barns_data: async function () {
      this.loading = true;
      await AWSAPI.getBarns(this.userData['farmer']['farmer_id'])
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.barnsData = res['data']['data'];
          }
        });
    },
    get_birth_data: async function (id) {
      await AWSAPI.getBirths(id)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.birthData = res['data']['data'];
            this.loading = false
          }
        });
    },
    birthInfoDataSet() {
      this.birthInfoData = [];
      for (let idx = 0; idx < this.birthData.length; idx++) {
        let tempCows = [];
        if ("cow_id" in this.barnsData[idx]) {
          for (let idy = 0; idy < this.barnsData[idx]["cow_id"].length; idy++) {
            let temp_id = this.selectCowsDataID(this.barnsData[idx]["cow_id"][idy]);
            if (temp_id != -1) {
              tempCows.push(this.cowsData[temp_id]);
            }
          }
        }
        let tempData = {
          "id": idx,
          "select_name": "履歴" + (idx + 1),
          "birth_id": this.birthData[idx]["birth_id"],
        }
        this.birthInfoData.push(tempData);
      }
    },
    barnsInfoDataSet() {
      this.barnsInfoData = [];
      for (let idx = 0; idx < this.barnsData.length; idx++) {
        let tempCows = [];
        if ("cow_id" in this.barnsData[idx]) {
          for (let idy = 0; idy < this.barnsData[idx]["cow_id"].length; idy++) {
            let temp_id = this.selectCowsDataID(this.barnsData[idx]["cow_id"][idy]);
            if (temp_id != -1) {
              tempCows.push(this.cowsData[temp_id]);
            }
          }
        }
        let tempData = {
          "id": idx,
          "barn_id": this.barnsData[idx]["barn_id"],
          "barn_name": this.barnsData[idx]["barn_name"],
          "cow_data": tempCows
        }
        this.barnsInfoData.push(tempData);
      }
      if (this.barnsInfoData.length > 0) {
        this.alert_barn = this.barnsInfoData[0]["barn_id"];
      }
    },
    selectCowsDataID(cow_id) {
      let ret = -1;
      for (let idx = 0; idx < this.cowsData.length; idx++) {
        if ("cow_id" in this.cowsData[idx] && this.cowsData[idx]["cow_id"] === cow_id) {
          ret = idx;
          break;
        }
      }
      return ret;
    },
    itemCheck() {
      if (this.cow_number === "") {
        this.viewMessage("個体識別番号が入力されておりません。", "error");
        return false;
      }
      if (!isNumberString(this.cow_number) || this.cow_number.length != 10) {
        this.viewMessage(ConstParam.number_error_message, "error");
        return false;
      }
      return true;
    },
    deleteBirthHistoryCheck() {
      if (this.tableBirthData[0].birth_id == this.birth_id) {
        this.viewMessage("最新の出産は削除出来ません。各項目の入力値を変更してください。", "error");
        return false;
      }
      return true;
    },
    set_estrus_on(estrusOn) {
      this.birth_estrus_on = [];
      for (let idx = 0; idx < estrusOn.length; idx++) {
        this.birth_estrus_on.push({ date: estrusOn[idx] });
      }
    },
    get_estrus_on() {
      let tempEstrusOn = [];
      for (let idx = 0; idx < this.birth_estrus_on.length; idx++) {
        tempEstrusOn.push(this.birth_estrus_on[idx].date);
      }
      return tempEstrusOn;
    },
    get_inseminate() {
      let tempInseminate = [];
      for (let idx = 0; idx < this.birth_inseminate.length; idx++) {
        let tempMethod = 0;
        let tempBullId = "";
        let tempEggId = "";
        if ("method" in this.birth_inseminate[idx]) {
          tempMethod = this.birth_inseminate[idx]['method'];
        }
        if ("bull_id" in this.birth_inseminate[idx]) {
          tempBullId = this.birth_inseminate[idx]['bull_id'];
        }
        if ("egg" in this.birth_inseminate[idx] && "egg_id" in this.birth_inseminate[idx]['egg']) {
          tempEggId = this.birth_inseminate[idx]['egg']['egg_id'];
        }
        let tempData = {
          method: tempMethod,
          date: this.birth_inseminate[idx]['date'],
          inseminator: this.birth_inseminate[idx]['inseminator'],
          transfer: this.birth_inseminate[idx]['transfer'],
          bull_id: tempBullId,
          egg_id: tempEggId
        }
        tempInseminate.push(tempData);
      }
      return tempInseminate;
    },
    get_pregnancy() {
      let tempPregnancy = [];
      for (let idx = 0; idx < this.birth_pregnancy.length; idx++) {
        let tempData = {
          is_pregnancy: this.birth_pregnancy[idx]['is_pregnancy'] === this.cow_pregnancy_select[0].kind ? true : false,
          date: this.birth_pregnancy[idx]['date']
        }
        tempPregnancy.push(tempData);
      }
      return tempPregnancy;
    },
    get_birth() {
      let tempBirth = {
        is_birth: this.is_birth === "出産" ? true : false,
        date: this.is_birth_date,
        calf_name: this.calf_name,
        calf_number: this.calf_number
      }
      if (this.calf_name === "" && this.calf_number === "") {
        this.calf_id = "";
      }
      return tempBirth;
    },
    addBirth: async function (id, success_message) {
      await AWSAPI.addBirth(
        id,
        this.get_estrus_on(),
        this.get_inseminate(),
        this.get_pregnancy(),
        this.birth_reserve_date,
        this.get_birth(),
        this.calf_id,
        this.amnion === "する" ? true : false
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.cow_select = "";
            this.cow_edit = false;
            this.getCowsDataUpdate();
            this.viewMessage(success_message, "success");
          }
        });
    },
    updateBirth: async function (id, success_message) {
      this.loading = true;
      await AWSAPI.updateBirth(
        id,
        this.get_estrus_on(),
        this.get_inseminate(),
        this.get_pregnancy(),
        this.birth_reserve_date,
        this.get_birth(),
        this.calf_id,
        this.amnion === "する" ? true : false
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            let tempMessage = success_message;
            if (this.cow_history) {
              tempMessage = "出産履歴を更新しました。";
              this.get_birth_data(this.cow_select);
            } else {
              this.cow_select = "";
              this.getCowsDataUpdate();
            }
            this.cow_edit = false;
            this.viewMessage(tempMessage, "success");
          } else {
            this.loading = false;
          }
        });
    },
    deleteBirth: async function (id) {
      this.loading = true;
      await AWSAPI.deleteBirth(id)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.select_history = "";
            this.cow_edit = false;
            this.loading = true;
            this.get_birth_data(this.cow_select);
            this.viewMessage("出産履歴を削除しました。", "success");
          }
        });
    },
    historyCancel() {
      this.cow_history = false;
      this.return_history = true;
      this.loading = true;
      this.getCowsDataUpdate();
    },
    historyEditCancel() {
      this.cow_edit = false;
      this.getBirthData(this.select_history);
    },
    birthInfoEntry() {
      // 更新
      if (!this.itemCheck()) {
        return;
      }
      let message = "出産履歴を更新しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '更新',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.updateBirth(this.birth_id);
      }).catch(() => {
        return
      });
    },
    birthInfoDelete() {
      // 削除
      if (!this.itemCheck()) {
        return;
      }
      // 最新履歴かチェック
      if (!this.deleteBirthHistoryCheck()) {
        return;
      }
      let message = "出産履歴を削除しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.deleteBirth(this.birth_id);
      }).catch(() => {
        return
      });
    },
    cowInfoEntry() {
      // 登録・更新
      if (!this.itemCheck()) {
        return;
      }
      let message = "牛情報を登録・更新しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '登録・更新',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.cowInfoDataEntry(this.cow_select);
      }).catch(() => {
        return
      });
    },
    cowInfoDataSet(cow_id) {
      // 初期化
      this.calf_name = "";
      this.calf_number = "";
      this.calf_id = "";
      this.is_birth_date = "";
      this.numberView = false;
      this.cow_image = "";
      this.cow_name = "";
      this.cow_number = "";
      this.cow_status = "未選択";
      this.cow_breed = "未選択";
      this.cow_sex = "未選択";
      this.cow_birth = "";
      this.birth_count = "0";
      this.amnion = "しない";
      this.estrus_on = "";
      this.bull_code = "";
      this.inseminate_on = "";
      this.inseminate_on_info = "";
      this.inseminator = "";
      this.egg = "";
      this.transfer = "";
      this.transfer_on = "";
      this.transfer_on_info = "";
      this.pregnancy_on = "";
      this.birth_estrus_on = [];
      this.birth_inseminate = [];
      this.birth_pregnancy = [];
      this.birth_reserve_date = "";
      this.birth_on_status = "";
      this.birth_on = "";
      this.is_birth = "出産";
      this.fa_fa_fa = "";
      this.fa_mo_fa = "";
      this.mo = "";
      this.fa_fa = "";
      this.mo_fa_fa = "";
      this.fa = "";
      this.mo_fa = "";
      this.fa_mo = "";
      this.mo_mo = "";
      this.mo_mo_fa = "";
      if (cow_id === "新規登録") {
        // 新規データ設定のため処理終了
        this.cow_status = "成牛";
        this.cow_breed = "黒毛和牛";
        this.cow_sex = "メス";
        this.cow_status_edit = "成牛";
        this.cow_breed_edit = "黒毛和牛";
        this.cow_sex_edit = "メス";
        return;
      }
      let idx = this.selectCowsDataID(cow_id);
      if (idx == -1) {
        // データ削除済みのため一覧表示
        this.cow_select = "";
        this.cow_edit = false;
        this.loading = false;
        return;
      }
      // 取得済みデータのセット
      // 個体情報
      if ("cow_name" in this.cowsData[idx]) { this.cow_name = this.cowsData[idx]["cow_name"] }
      if ("cow_number" in this.cowsData[idx]) { this.cow_number = this.cowsData[idx]["cow_number"] }
      if ("cow_breed" in this.cowsData[idx]) { this.cow_breed = this.cow_kinds[this.cowsData[idx]["cow_breed"]] } else { this.cow_breed = this.cow_kinds[this.cow_kinds.length - 1] }
      if ("cow_sex" in this.cowsData[idx]) { this.cow_sex = this.cow_sexs[this.cowsData[idx]["cow_sex"]] } else { this.cow_sex = this.cow_sexs[2] }
      if ("cow_status" in this.cowsData[idx]) { this.cow_status = this.cow_status_kinds[this.cowsData[idx]["cow_status"]] } else { this.cow_status = this.cow_status_kinds[4] }
      if ("cow_birth" in this.cowsData[idx]) { this.cow_birth = this.cowsData[idx]["cow_birth"] }
      if ("birth_count" in this.cowsData[idx]) { this.birth_count = this.cowsData[idx]["birth_count"] }
      // 出産状況
      if ("last_birth" in this.cowsData[idx]) {
        if ("estrus_on" in this.cowsData[idx]["last_birth"]) { this.estrus_on = this.cowsData[idx]["last_birth"]["estrus_on"] }
        if ("pregnancy_on" in this.cowsData[idx]["last_birth"]) { this.pregnancy_on = this.cowsData[idx]["last_birth"]["pregnancy_on"] }
        if ("is_birth" in this.cowsData[idx]["last_birth"]) { this.is_birth = this.cowsData[idx]["last_birth"]["is_birth"] ? '出産' : '死産・流産' }
        if ("birth_on" in this.cowsData[idx]["last_birth"]) {
          this.birth_on = this.cowsData[idx]["last_birth"]["birth_on"]
          if (this.birth_on !== "") {
            this.birth_on_status = this.birth_on + " (" + this.is_birth + ")";
          } else {
            this.birth_on_status = "";
          }
        }
        if ("inseminate_on" in this.cowsData[idx]["last_birth"]) { this.inseminate_on = this.cowsData[idx]["last_birth"]["inseminate_on"] }
        if ("inseminator" in this.cowsData[idx]["last_birth"]) { this.inseminator = this.cowsData[idx]["last_birth"]["inseminator"] }
        if ("bull" in this.cowsData[idx]["last_birth"]) { this.bull_code = this.cowsData[idx]["last_birth"]["bull"] }
        if ("birth_reserve_date" in this.cowsData[idx]["last_birth"]) { this.birth_reserve_date = this.cowsData[idx]["last_birth"]["birth_reserve_date"] }
        if (this.inseminate_on !== "") {
          this.inseminate_on_info = this.inseminate_on + " (" + this.inseminator + "/" + this.bull_code + ")";
        }
        // 受精卵移植
        if ("transfer_on" in this.cowsData[idx]["last_birth"]) { this.transfer_on = this.cowsData[idx]["last_birth"]["transfer_on"] }
        if ("transfer" in this.cowsData[idx]["last_birth"]) { this.transfer = this.cowsData[idx]["last_birth"]["transfer"] }
        if ("egg" in this.cowsData[idx]["last_birth"]) { this.egg = this.cowsData[idx]["last_birth"]["egg"] }
        if (this.transfer_on !== "") {
          this.transfer_on_info = this.transfer_on + " (" + this.transfer + "/" + this.egg + ")";
        }
      }
      if ("is_lick_amnion" in this.cowsData[idx]) { this.amnion = this.cowsData[idx]["is_lick_amnion"] ? "する" : "しない" }
      if ("pedigree" in this.cowsData[idx]) {
        if ("fa_fa_fa" in this.cowsData[idx]["pedigree"]) { this.fa_fa_fa = this.cowsData[idx]["pedigree"]["fa_fa_fa"] }
        if ("fa_mo_fa" in this.cowsData[idx]["pedigree"]) { this.fa_mo_fa = this.cowsData[idx]["pedigree"]["fa_mo_fa"] }
        if ("mo" in this.cowsData[idx]["pedigree"]) { this.mo = this.cowsData[idx]["pedigree"]["mo"] }
        if ("fa_fa" in this.cowsData[idx]["pedigree"]) { this.fa_fa = this.cowsData[idx]["pedigree"]["fa_fa"] }
        if ("mo_fa_fa" in this.cowsData[idx]["pedigree"]) { this.mo_fa_fa = this.cowsData[idx]["pedigree"]["mo_fa_fa"] }
        if ("fa" in this.cowsData[idx]["pedigree"]) { this.fa = this.cowsData[idx]["pedigree"]["fa"] }
        if ("mo_fa" in this.cowsData[idx]["pedigree"]) { this.mo_fa = this.cowsData[idx]["pedigree"]["mo_fa"] }
        if ("fa_mo" in this.cowsData[idx]["pedigree"]) { this.fa_mo = this.cowsData[idx]["pedigree"]["fa_mo"] }
        if ("mo_mo" in this.cowsData[idx]["pedigree"]) { this.mo_mo = this.cowsData[idx]["pedigree"]["mo_mo"] }
        if ("mo_mo_fa" in this.cowsData[idx]["pedigree"]) { this.mo_mo_fa = this.cowsData[idx]["pedigree"]["mo_mo_fa"] }
      }
      if ("face_image_date" in this.cowsData[idx] && this.cowsData[idx]['face_image_date'] !== "") {
        this.cow_image = (this.farmer_id + "/" + cow_id + "/face_tmb.jpg").replaceAll('#', '%23');
      } else {
        this.cow_image = "";
      }
      // 未選択関連
      this.cow_status_edit = (this.cow_status === "未選択") ? "成牛" : this.cow_status;
      this.cow_breed_edit = (this.cow_breed === "未選択") ? "黒毛和牛" : this.cow_breed;
      this.cow_sex_edit = (this.cow_sex === "未選択") ? "メス" : this.cow_sex;

      this.loading = false;
    },
    cowInfoDataEntry: async function (cow_id) {
      // 初期化
      // データのセット
      let tempPedigree = {
        "fa": this.fa,
        "fa_fa": this.fa_fa,
        "fa_mo": this.fa_mo,
        "fa_fa_fa": this.fa_fa_fa,
        "fa_mo_fa": this.fa_mo_fa,
        "mo": this.mo,
        "mo_fa": this.mo_fa,
        "mo_mo": this.mo_mo,
        "mo_fa_fa": this.mo_fa_fa,
        "mo_mo_fa": this.mo_mo_fa
      }
      let tempCowName = this.cow_name;
      if (this.cow_name === "") {
        // 名前未入力時は耳標・拡大4桁を名前に入力する
        tempCowName = this.cow_number.substring(5, 9);
      }
      if (cow_id === "新規登録") {
        await AWSAPI.addCowBirth(
          this.userData['farmer']['farmer_id'],
          tempCowName,
          (this.cow_sex_edit === "メス") ? 0 : 1,
          this.cow_birth,
          this.cow_number,
          this.cow_kinds.indexOf(this.cow_breed_edit),
          this.cow_status_kinds.indexOf(this.cow_status_edit),
          0,
          tempPedigree,
          this.get_estrus_on(),
          this.get_inseminate(),
          this.get_pregnancy(),
          this.birth_reserve_date,
          this.get_birth(),
          this.calf_id,
          this.amnion === "する" ? true : false
        )
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              let tempMessage = "牛情報を追加しました。";
              if (this.cow_name === "") {
                tempMessage = "名前を「" + tempCowName + "」で登録しました。";
              }
              this.cow_select = "";
              this.cow_edit = false;
              // this.filterAllReset();
              this.viewMessage(tempMessage, "success");
              this.getCowsDataUpdate();
            }
          });
      } else {
        await AWSAPI.updateCow(
          cow_id,
          tempCowName,
          (this.cow_sex_edit === "メス") ? 0 : 1,
          this.cow_birth,
          this.cow_number,
          this.cow_kinds.indexOf(this.cow_breed_edit),
          this.cow_status_kinds.indexOf(this.cow_status_edit),
          0,
          tempPedigree
        )
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              if (this.birth_id === "") {
                let tempMessage = "牛情報を追加しました。";
                if (this.cow_name === "") {
                  tempMessage = "名前を「" + tempCowName + "」で登録しました。";
                }
                this.addBirth(res["data"]["data"][0]["cow_id"], tempMessage);
              } else {
                let tempMessage = "牛情報を更新しました。";
                if (this.cow_name === "") {
                  tempMessage = "名前を「" + tempCowName + "」で更新しました。";
                }
                this.updateBirth(this.birth_id, tempMessage);
              }
              // this.filterAllReset();
            }
          });
      }
    },
    cowInfoDataDelete: async function () {
      // 初期化
      let message = "牛情報を削除しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        AWSAPI.deleteCow(this.cow_select)
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.viewMessage("牛情報を削除しました。", "success");
              this.cow_select = "";
              this.cow_edit = false;
              // this.filterAllReset();
              this.getCowsDataUpdate();
            }
          });
      });
    },
    getBirthData(id) {
      this.amnion = "する";
      this.birth_estrus_on = [];
      this.birth_inseminate = [];
      this.birth_pregnancy = [];
      this.birth_id = "";
      this.is_birth = "出産";
      this.is_birth_date = "";
      this.birth_reserve_date = "";
      this.calf_name = "";
      this.calf_name_info = "";
      this.calf_number = "";
      this.calf_id = "";
      for (let idx = 0; idx < this.birthData.length; idx++) {
        if ("履歴" + (this.birthData.length - idx) === id) {
          this.birth_id = this.birthData[idx]['birth_id'];
          this.is_birth = "出産";
          this.is_birth_date = "";
          if ("birth_reserve_date" in this.birthData[idx]) {
            this.birth_reserve_date = this.birthData[idx]['birth_reserve_date']
          }
          this.calf_name = "";
          this.calf_number = "";
          this.calf_id = "";
          if ("birth" in this.birthData[idx]) {
            this.is_birth = this.birthData[idx]['birth']['is_birth'] ? '出産' : '死産・流産';
            this.is_birth_date = this.birthData[idx]['birth']['date'];
            if ("calf_name" in this.birthData[idx]['birth']) {
              this.calf_name = this.birthData[idx]['birth']['calf_name'];
            }
            if ("calf_number" in this.birthData[idx]['birth']) {
              this.calf_number = this.birthData[idx]['birth']['calf_number'];
            }
            if ("calf_id" in this.birthData[idx]) {
              this.calf_id = this.birthData[idx]['calf_id'] == null ? "" : this.birthData[idx]['calf_id'];
            }
          }
          this.calf_name_info = this.calf_name;
          this.calf_name_info += "(" + this.calf_number + ")";
          if (this.calf_name_info === "()") {
            this.calf_name_info = "";
          }
          this.amnion = this.birthData[idx]['is_lick_amnion'] ? 'する' : 'しない';
          this.set_estrus_on(this.birthData[idx]['estrus_on']);
          this.birth_inseminate = JSON.parse(JSON.stringify(this.birthData[idx]['inseminate']));
          if (this.birth_inseminate.length > 0) {
            for (let idy = 0; idy < this.birth_inseminate.length; idy++) {
              this.birth_inseminate[idy]['method_str'] = "0";
              if ("method" in this.birth_inseminate[idy]) {
                this.birth_inseminate[idy]['method_str'] = String(this.birth_inseminate[idy]['method']);
              }
              if ("bull" in this.birth_inseminate[idy]) {
                this.birth_inseminate[idy]['bull_id'] = this.birth_inseminate[idy]['bull']['bull_id'];
                this.birth_inseminate[idy]['bull_name'] = this.birth_inseminate[idy]['bull']['bull_name'];
              } else {
                this.birth_inseminate[idy]['bull_id'] = "";
                this.birth_inseminate[idy]['bull_name'] = "";
              }
              if ("egg" in this.birth_inseminate[idy]) {
                this.birth_inseminate[idy]['egg_id'] = this.birth_inseminate[idy]['egg']['egg_id'];
                this.birth_inseminate[idy]['fa_name'] = this.birth_inseminate[idy]['egg']['fa_name'];
                this.birth_inseminate[idy]['mo_name'] = this.birth_inseminate[idy]['egg']['mo_name'];
                this.birth_inseminate[idy]['egg_name'] = this.birth_inseminate[idy]['fa_name'] + "/" + this.birth_inseminate[idy]['mo_name'];
              } else {
                this.birth_inseminate[idy]['egg_id'] = "";
                this.birth_inseminate[idy]['fa_name'] = "";
                this.birth_inseminate[idy]['mo_name'] = "";
                this.birth_inseminate[idy]['egg_name'] = "";
              }
            }
          }
          this.birth_pregnancy = [];
          for (let idy = 0; idy < this.birthData[idx]['pregnancy'].length; idy++) {
            let tempPregnancy = {
              is_pregnancy: (this.birthData[idx]['pregnancy'][idy]['is_pregnancy'] ? this.cow_pregnancy_select[0].kind : this.cow_pregnancy_select[1].kind),
              date: this.birthData[idx]['pregnancy'][idy]['date']
            }
            this.birth_pregnancy.push(tempPregnancy);
          }
        }
      }
    },
    getBirthHistory(id) {
      for (let idx = 0; idx < this.tableBirthData.length; idx++) {
        if (this.tableBirthData[idx]['history_name'] === id) {
          this.estrus_on = this.tableBirthData[idx]['estrus_on'];
          this.estrus_on_array = this.tableBirthData[idx]['estrus_on_array'];
          this.inseminate_on_info = this.tableBirthData[idx]['inseminate_date_name'];
          this.inseminate_date_name_array = this.tableBirthData[idx]['inseminate_date_name_array'];
          this.transfer_on_info = this.tableBirthData[idx]['transfer_date_name'];
          this.transfer_date_name_array = this.tableBirthData[idx]['transfer_date_name_array'];
          this.pregnancy_on = this.tableBirthData[idx]['pregnancy_date_flg'];
          this.pregnancy_date_flg_array = this.tableBirthData[idx]['pregnancy_date_flg_array'];
          this.birth_on_status = this.tableBirthData[idx]['birth_date_flg'];
          this.calf_name = this.tableBirthData[idx]['calf_name'];
          this.calf_number = this.tableBirthData[idx]['calf_number'];
          this.calf_id = this.tableBirthData[idx]['calf_id'];
          this.calf_name_info = this.calf_name;
          this.calf_name_info += "(" + this.calf_number + ")";
          if (this.calf_name_info === "()") {
            this.calf_name_info = "";
          }
          this.amnion = this.tableBirthData[idx]['is_lick_amnion'];
          let birthId = this.tableBirthData[idx]['birth_id'];
          this.get_alerts_data(birthId);
          break;
        }
      }
    },
    editHistory() {
      this.numberView = false;
      this.cow_edit = true;
      this.changeHistory();
    },
    changeHistory() {
      if (this.cow_edit) {
        this.getBirthData(this.select_history);
      } else {
        this.getBirthHistory(this.select_history);
      }
    },
    get_alerts_data: async function (birth_id) {
      this.loading = true;
      await AWSAPI.getBirthAlerts(birth_id)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.alertsData = res['data']['data'];
          }
        });
    },
    get_calf_alerts_data: async function (select_cow_id) {
      if (select_cow_id !== "") {
        this.loading = true;
        await AWSAPI.getCalfAlerts(select_cow_id)
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.alertsData = res['data']['data'];
            }
          });
      } else {
        this.loading = false;
      }
    },
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin
      this.filterParam = this.$store.state.cowManageFilterParam
      if (!this.filterParam || !this.filterParam.save) {
        this.$store.commit('setCowManageFilterParam', constFilterParam)
        this.filterParam = this.$store.state.cowManageFilterParam
      }
      this.setFilterParam()
      this.setSortParam()
    },
    // ここから後ろは固定
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
        this.$cookies.set('Authorization', this.idToken);
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status,
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
  },
  watch: {
    cowNumberNames: function () {
      this.setSuggestionsDatas(this.cowNumberNames)
    },
    isSearchNumber: function () {
      this.search_text = ""
      if (this.isSearchNumber) {
        // 耳標・拡張４桁
        this.search_text_placeholder = ConstParam.search_text_placeholder_number
        this.search_text_maxlength = ConstParam.number_maxLength
        this.setSuggestionsData()
      } else {
        // 名前
        this.search_text_placeholder = ConstParam.search_text_placeholder_name
        this.search_text_maxlength = ConstParam.maxLength
        this.setSuggestionsData()
      }
      this.filterUpdate()
    },
    cow_birth: function () {
      if (this.cow_birth === "") {
        this.cow_birth_jpn = ""
        return
      }
      try {
        const date = new Date(this.cow_birth)
        this.cow_birth_jpn = new Intl.DateTimeFormat('ja-JP-u-ca-japanese', { dateStyle: 'long' }).format(date)
      } catch (e) {
        this.cow_birth_jpn = ""
        return
      }
    },
    addFlag: function () {
      this.addNumber++
      if (this.addNumber <= 2000) {
        this.cowInfoDataEntryDummy()
      }
    },
    deleteFlag: function () {
      this.deleteIndex++
      if (this.tableData.length > this.deleteIndex) {
        this.deleteCowData()
      }
    },
    //
    eggData: function () {
      // 受精卵設定
      this.eggNameSet(this.eggData);
      this.loading = false;
    },
    bullData: function () {
      // 種雄牛名設定
      this.bullNameSet(this.bullData);
      this.loading = false;
    },
    farmerData: function () {
      // 人工授精師設定
      this.inseminatorSet(this.farmerData[0]);
      // 移植師設定
      this.transferSet(this.farmerData[0]);
      this.loading = false;
    },
    alertsData: function () {
      this.alertsTable = [];
      for (let idx = 0; idx < this.alertsData.length; idx++) {
        let thumbnailPath = "";
        let imagePath = "";
        let imageType = "jpg";
        let alertType = this.alertsData[idx]['alert_type'];
        if ("thumbnail_path" in this.alertsData[idx] && this.alertsData[idx]['thumbnail_path'] !== "") {
          thumbnailPath = this.alertsData[idx]['thumbnail_path'];
          imagePath = thumbnailPath.replaceAll('_tmb', '');
        }
        if (imagePath === "") {
          imageType = "png";
          if (alertType == 4) {
            // 歩数
            imageType = "step";
          } else if (alertType == 6) {
            // 捕食
            imageType = "eat";
          } else if (alertType == 7) {
            // 姿勢
            imageType = "stance";
          } else if (alertType == 8) {
            // 旋回
            imageType = "spin";
            // } else if (alertType == 100) {
            //   // 初乳
            //   imageType = "foremilk";
          } else if (alertType == 101) {
            // 子牛移動量低下
            imageType = "calf";
          } else {
            imageType = "no";
          }
        }
        let tempData = {
          "event": this.alertsData[idx]['event'],
          "date_time": this.alertsData[idx]['date_time'],
          "alert_type": alertType,
          "is_action": this.alertsData[idx]['is_action'],
          "is_lock": this.alertsData[idx]['is_lock'],
          "is_read": this.alertsData[idx]['is_read'],
          "is_wrong_detect": this.alertsData[idx]['is_wrong_detect'],
          "message": this.getAlertMessage(alertType),
          "datetime": dayjs(this.alertsData[idx].date_time).format('HH:mm'),
          "imagePath": thumbnailPath,
          "imageType": imageType,
          "fullSizeImagePath": imagePath,
          "view_date_time": dayjs(this.alertsData[idx].date_time).format('YYYY/MM/DD(ddd) HH:mm')
        }
        this.alertsTable.push(tempData);
      }
      this.loading = false;
    },
    userData: function () {
      if ('farmer' in this.userData && 'pregnancy_term' in this.userData['farmer']) {
        this.pregnancy_term = this.userData['farmer']['pregnancy_term'];
      }
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData['user_name'];
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData['farmer']) {
        this.viewFarmerName = this.userData['farmer']['farmer_name'];
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData['farmer']) {
        this.farmer_id = this.userData['farmer']['farmer_id'];
      }
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      // 受精卵設定
      this.eggNameSet(this.userData['farmer']['eggs']);
      // 種雄牛名設定
      this.bullNameSet(this.userData['farmer']['bulls']);
      // 人工授精師設定
      this.inseminatorSet(this.userData['farmer']);
      // 移植師設定
      this.transferSet(this.userData['farmer']);
      // 牛房情報取得
      this.get_barns_data();
    },
    barnsData: function () {
      // 牛情報取得
      this.getCowsDataFirst();
      this.barnsInfoDataSet();
    },
    sortCowsData: function () {
      // get_sort_cows対応
      this.sortCowsListData.push(this.sortCowsData.data)
      this.sortCowsListCount.push(this.sortCowsData.data.length)
      this.sortCowsIndexCount++
      this.sortCowsTotalCount = this.getSortCowsCount()
      this.cowsData = structuredClone(this.sortCowsData.data)
      if ("last_key" in this.sortCowsData) {
        this.sortCowsListKey = structuredClone(this.sortCowsData.last_key)
        this.sortCowsListKeyArray.push(this.sortCowsData.last_key)
        this.sortCowsTotalCount++
      } else {
        this.sortCowsListKeyArray.push({})
      }
    },
    updateSortCowsData: function () {
      // get_sort_cows対応
      this.sortCowsListData[this.sortCowsIndex] = structuredClone(this.updateSortCowsData.data)
      this.cowsData = structuredClone(this.updateSortCowsData.data)
    },
    cowsData: function () {
      // 牛一覧情報作成
      let tempTable = [];
      for (let idx = 0; idx < this.cowsData.length; idx++) {
        let tempBarn = "";
        for (let idy = 0; idy < this.barnsData.length; idy++) {
          if ("cow_id" in this.barnsData[idy] && "cow_id" in this.cowsData[idx]) {
            if (this.barnsData[idy]['cow_id'].indexOf(this.cowsData[idx]['cow_id']) != -1) {
              tempBarn = this.barnsData[idy]['barn_name'];
              break;
            }
          }
        }
        let tempBreed = this.cow_kinds.length - 1;
        if ("cow_breed" in this.cowsData[idx]) {
          tempBreed = this.cowsData[idx]['cow_breed'];
        }
        let tempTransferDate = "";
        if ("transfer_on" in this.cowsData[idx]['last_birth']) {
          tempTransferDate = this.cowsData[idx]['last_birth']['transfer_on'];
        }
        this.cowsData[idx]['last_birth']['inseminate_on']
        let tempData = {
          "id": this.cowsData[idx]['cow_id'],
          "no": this.cowsData[idx]['cow_number'],
          "name": this.cowsData[idx]['cow_name'],
          "sex": this.cowsData[idx]['cow_sex'],
          "breed": this.cow_kinds[tempBreed],
          "birthdate": this.cowsData[idx]['last_birth']['birth_reserve_date'],
          "fertilizationdate": this.cowsData[idx]['last_birth']['inseminate_on'],
          "transferdate": tempTransferDate,
          "lastestruson": this.cowsData[idx]['last_birth']['estrus_on'],
          "lastbirthon": this.cowsData[idx]['last_birth']['birth_on'],
          "barn": tempBarn,
          "status": this.cowsData[idx]['cow_status'],
          "pregnancystatus": this.cowsData[idx]['cow_pregnancy_status']
        }
        tempTable.push(tempData);
      }
      this.tableData = tempTable;
      this.orgTableData = this.tableData;
      if (!this.cow_history && !this.return_history) {
        this.loading = false;
      }
      this.return_history = false;
      if (this.cow_select !== "") {
        this.cowInfoDataSet(this.cow_select);
      }
    },
    birthData: function () {
      // 出産履歴情報作成
      this.birth_id = "";
      this.birth_estrus_on = [];
      this.birth_inseminate = [];
      this.birth_pregnancy = [];
      this.tableBirthData = [];
      this.select_history = "履歴" + this.birthData.length;
      this.maxBirthHistory = this.select_history;
      this.getBirthData(this.select_history);
      for (let idx = 0; idx < this.birthData.length; idx++) {
        try {
          let tempEstrusOn = "";
          let tempEstrusOnArray = [];
          for (let idy = 0; idy < this.birthData[idx]['estrus_on'].length; idy++) {
            tempEstrusOn = this.birthData[idx]['estrus_on'][idy];
            if (tempEstrusOn !== "") {
              tempEstrusOnArray.push(tempEstrusOn);
            }
          }
          let tempInseminateDate = "";
          let tempInseminator = "";
          let tempBullName = "";
          let tempBullId = "";
          let tempInseminateDateName = "";
          let tempInseminateDateNameArray = [];
          let tempTransferDate = "";
          let tempTransfer = "";
          let tempFaName = "";
          let tempMoName = "";
          let tempEggName = "";
          let tempEggId = "";
          let tempTransferDateName = '';
          let tempTransferDateNameArray = [];
          for (let idy = 0; idy < this.birthData[idx]['inseminate'].length; idy++) {
            let tempMethod = 0;
            if ('method' in this.birthData[idx]['inseminate'][idy]) {
              tempMethod = this.birthData[idx]['inseminate'][idy]['method'];
              this.birthData[idx]['inseminate'][idy]['method_str'] = String(tempMethod);
            }
            if (tempMethod == 0) {
              tempInseminateDate = this.birthData[idx]['inseminate'][idy]['date'];
              tempInseminator = this.birthData[idx]['inseminate'][idy]['inseminator'];
              tempBullName = "";
              tempBullId = "";
              if ("bull" in this.birthData[idx]['inseminate'][idy]) {
                if ("bull_name" in this.birthData[idx]['inseminate'][idy]['bull']) {
                  tempBullName = this.birthData[idx]['inseminate'][idy]['bull']['bull_name'];
                  tempBullId = this.birthData[idx]['inseminate'][idy]['bull']['bull_id'];
                }
              }
              tempInseminateDateName = tempInseminateDate;
              tempInseminateDateName += "（" + tempInseminator + "/" + tempBullName + "） ";
              tempInseminateDateNameArray.push(tempInseminateDateName);
            } else {
              tempTransferDate = this.birthData[idx]['inseminate'][idy]['date'];
              tempTransfer = this.birthData[idx]['inseminate'][idy]['transfer'];
              tempEggId = "";
              tempFaName = "";
              tempMoName = "";
              if ("egg" in this.birthData[idx]['inseminate'][idy]) {
                if ("egg_id" in this.birthData[idx]['inseminate'][idy]['egg']) {
                  tempEggId = this.birthData[idx]['inseminate'][idy]['egg']['egg_id'];
                  tempFaName = this.birthData[idx]['inseminate'][idy]['egg']['fa_name'];
                  tempMoName = this.birthData[idx]['inseminate'][idy]['egg']['mo_name'];
                }
              }
              tempTransferDateName = tempTransferDate;
              if (tempFaName !== "" || tempMoName !== "") {
                tempEggName = tempFaName + "/" + tempMoName
              } else {
                tempEggName = "";
              }
              tempTransferDateName += "（" + tempTransfer + "/" + tempEggName + "）";
              tempTransferDateNameArray.push(tempTransferDateName);
            }
          }
          let tempPregnancyDate = '';
          let tempPregnancyDateFlg = '';
          let tempPregnancyDateFlgArray = [];
          for (let idy = 0; idy < this.birthData[idx]['pregnancy'].length; idy++) {
            tempPregnancyDate = this.birthData[idx]['pregnancy'][idy]['date'];
            let tempFlg = this.birthData[idx]['pregnancy'][idy]['is_pregnancy'] ? 0 : 1;
            tempPregnancyDateFlg = tempPregnancyDate + "（" + this.cow_pregnancy_select[tempFlg].kind + '）';
            tempPregnancyDateFlgArray.push(tempPregnancyDateFlg);
          }
          let tempBirthDate = "";
          let tempCalfName = "";
          let tempCalfNumber = "";
          let tempCalfId = "";
          let tempBirthDateFlg = "";
          if ("birth" in this.birthData[idx]) {
            let tempFlg = this.birthData[idx]['birth']['is_birth'];
            tempBirthDate = this.birthData[idx]['birth']['date'];
            tempCalfName = this.birthData[idx]['birth']['calf_name'];
            tempCalfNumber = this.birthData[idx]['birth']['calf_number'];
            tempCalfId = this.birthData[idx]['calf_id'] == null ? "" : this.birthData[idx]['calf_id'];
            if (tempBirthDate && tempBirthDate !== "") {
              tempBirthDateFlg = tempBirthDate + "（" + (tempFlg ? '出産）' : '死産・流産）');
            }
          }
          let tempData = {
            "birth_id": this.birthData[idx]['birth_id'],
            "estrus_on": tempEstrusOn,
            "estrus_on_array": tempEstrusOnArray,
            "inseminate_date": tempInseminateDate,
            "inseminator": tempInseminator,
            "bull_name": tempBullName,
            "bull_id": tempBullId,
            "transfer_date": tempTransferDate,
            "transfer": tempTransfer,
            "egg_name": tempEggName,
            "egg_id": tempEggId,
            "pregnancy_date": tempPregnancyDate,
            "birth_reserve_date": this.birthData[idx]['birth_reserve_date'],
            "birth_date": tempBirthDate,
            "history_name": "履歴" + (this.birthData.length - idx),
            "inseminate_date_name": tempInseminateDateName,
            "inseminate_date_name_array": tempInseminateDateNameArray,
            "transfer_date_name": tempTransferDateName,
            "transfer_date_name_array": tempTransferDateNameArray,
            "pregnancy_date_flg": tempPregnancyDateFlg,
            "pregnancy_date_flg_array": tempPregnancyDateFlgArray,
            "birth_date_flg": tempBirthDateFlg,
            "calf_name": tempCalfName,
            "calf_number": tempCalfNumber,
            "calf_id": tempCalfId,
            "is_lick_amnion": this.birthData[idx]['is_lick_amnion'] ? 'する' : 'しない'
          }
          this.tableBirthData.push(tempData);
        } catch (e) {
          console.log(e);
        }
      }
      if (this.birthData.length == 0) {
        this.cow_history = false;
      }
      if (this.cow_history) {
        this.getBirthHistory(this.select_history);
      } else {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.width100 {
  width: 100%;
}

#cow-image {
  width: 136px;
  height: 136px;
  object-fit: cover;
}

.el-row {
  justify-content: left;
}

.title-area {
  padding: 12px 0 0 24px;
  font-size: 18px;
}

.body-area {
  padding: 0 36px 0 36px;
}

.body-area-one-line {
  padding: 36px 36px 0 36px;
}

.font-bold {
  font-weight: bold;
}

.birth {
  padding-left: 2em;
}

.birth_s {
  padding-left: 1em;
}

.birth-input {
  padding-left: 1em;
}

.font-small {
  font-size: small;
}

.button-color {
  color: #383838;
}

.gray-button {
  color: #383838;
  background: #EEEEEC;
}

.yellow-button {
  color: #383838;
  background: #ffdf5e;
}

.history-info {
  justify-content: center;
}

.history-info .el-select {
  width: 312px;
}

.history-info .el-select :deep(.el-input__wrapper) {
  padding: 0 11px 0 11px;
  border-radius: 20px;
  background-color: #FFDF5E;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.history-info .el-select :deep(.el-input__inner) {
  height: 50px;
  text-align: center;
}

.event-table .el-row,
.event-table td,
.event-table :deep(.el-table__cell) {
  padding: 0;
  border: none;
}

.el-button :deep(span) {
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}

.long-string {
  overflow-wrap: anywhere;
}

.filter-left {
  margin-left: 74px;
  font-size: 14px;
}

.bottom-padding {
  padding-bottom: 22px;
}

.left-button {
  width: 176px;
  height: 50px;
  color: #383838;
  background: #FFFFFF;
}

.right-button {
  width: 176px;
  height: 50px;
  margin-left: 44px !important;
  color: #383838;
  background: #ffdf5e;
}

.img-size {
  width: 214px;
  height: 120px;
}

.el-table__row:nth-child(odd):not(:hover) .el-table__cell {
  border-bottom: solid 2px blue !important;
}

.el-pagination {
  margin-top: 0.7em;
}

.v-center {
  align-content: center;
}

.el-select-v2--large .el-select-v2__wrapper .el-select-v2__combobox-input {
  margin-top: 6px !important;
}
</style>